<template>
  <div :class="allEyesModel ? 'MunicipalLevelData_eyeshield' : 'MunicipalLevelData'">
    <div id="svg-container"></div>
    <!-- 用于插入 SVG 的容器 -->

    <!-- <div class="openLeft" v-show="!openLeft" @click="openLeft = true">
      <img src="../../assets/img/2dmap/pop_close_open.png" alt="" />
    </div>
    <div class="closeLeft" v-show="openLeft" @click="openLeft = false">
      <img src="../../assets/img/2dmap/pop_close_open.png" alt="" />
    </div> -->
    <div class="leftContent" v-show="openLeft">
      <div class="screenItem">
        <div class="title">
          <!--            <div class="jiantou"></div> -->
          <span> 空域统计 </span>
        </div>
        <div class="screenItemContent">
          <div id="binCharts"></div>

          <div class="chartText">
            <div class="huContainer">
              <div class="lefthu"></div>
              <img class="bintu"
                :src="require(`../../assets/img/${allEyesModel ? '2dmap_eyes' : '2dmap'}/bing_tu_bg_in.png`)" alt="" />
              <div class="righthu"></div>
            </div>
            <!-- <img src="../../assets/img/2dmap/hu_right.png" alt=""> -->
            <div class="textArea">
              <div class="number">
                {{ maxAirSpaceItem.rate.toFixed(2) + "%" }}
              </div>
              <div class="text">{{ maxAirSpaceItem.name }}</div>
            </div>
          </div>

          <div class="dataContainer">
            <div class="areaData">
              <div class="areaContainer">
                <div class="areaRate">
                  {{ routeOriginData.forbidden }}
                </div>
                <div class="areaName">
                  禁飞区
                </div>
              </div>
              <div class="areaContainer">
                <div class="areaRate">
                  {{ routeOriginData.grid }}
                </div>
                <div class="areaName">
                  电子围栏
                </div>
              </div>
            </div>
            <div class="areaData">
              <div class="areaContainer">
                <div class="areaRate">
                  {{ routeOriginData.appropriate }}
                </div>
                <div class="areaName">
                  适飞区
                </div>
              </div>
              <div class="areaContainer">
                <div class="areaRate">
                  {{ routeOriginData.limit }}
                </div>
                <div class="areaName">
                  受限区
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="screenItemContent topBox">-->
        <!--          <div style="width: 100%;-->
        <!--          height: 100%;" id="routeCharts"></div>-->
        <!--        </div>-->
      </div>
      <div class="screenItem">
        <div class="title">
          <span> 空域使用次数 </span>
        </div>
        <div class="screenItemContent">
          <div style="width: 100%; height: 100%">
            <div class="levelWrap" style="margin-top:0 !important">
              <div class="RightBottomBottom" v-for="(item,index) in AirSpaceOccupancyRateData.numData" :key="index">
                <div class="shortShuFenge">{{ index + 1 }}</div>
                <div class="rightBottomBottomText" style="border-bottom: 2px solid #00AEFF;">
                  {{ AirSpaceOccupancyRateData.ydata.value[index] }}
                </div>
                <div class="processStyle">
                  <el-progress class="custom-progress" color="#00FFFF" :show-text="false" :text-inside="true"
                    :percentage="parseFloat(AirSpaceOccupancyRateData.sdata.value[index])
                      " status="exception"></el-progress>
                </div>
                <el-progress :text-inside="true" :percentage="50" status="exception"></el-progress>
                <div class="RightBottomBottomFigure">
                  {{ AirSpaceOccupancyRateData.numData[index] }}
                </div>
              </div>

              <!-- <div class="RightBottomBottom" v-for="(item, index) in AirSpaceOccupancyRateData">
                <div class="shortShuFenge">{{ index + 1 }}</div>
                <div class="rightBottomBottomText" style="border-bottom: 2px solid #00AEFF;">
                  {{
                    item.name
                  }}
                </div>
                <div class="processStyle">
                  <el-progress class="custom-progress"  :show-text="false" :text-inside="true"
                    :percentage="item.rate
                      " status="exception"></el-progress>
                </div>
                <div class="RightBottomBottomFigure">
                  {{
                    item.usenum
                  }}
                </div>

              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="screenItem">
        <div class="title">
          <span> 地面基础设施统计 </span>
        </div>
        <div class="screenItemContent topBox">
          <div style="display: flex;justify-content: space-between;width: 100%;">
            <div class="rightTopTop">
              <div class="rightTopTopContent">
                <div class="contentText">起降场数量</div>
                <div class="redLine" style="margin-top: 8px;"></div>
                <div class="contentFigure">
                                   {{
                                      this.facilitiesData.takeOffTotalNum != undefined
                                        ? this.facilitiesData.takeOffTotalNum
                                        : NaN
                                    }}
                </div>
              </div>
            </div>
            <div class="rightTopTop">
              <div class="rightTopTopContent">
                <div class="contentText" style="text-align: right;">
                  通导监测反制设备
                </div>

                <div class="redLine" style="float: right;margin-top: 8px;"></div>
                <div class="contentFigure" style="text-align: right;margin-top: 23px">
                  <!--                  {{-->
                  <!--                    this.facilitiesData.equipmentTotalNum != undefined-->
                  <!--                      ? this.facilitiesData.equipmentTotalNum-->
                  <!--                      : NaN-->
                  <!--                  }}-->
                  78
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex">
            <div class="rightTopBottom" style="margin-right: 8px">
              <div class="rightTopTopTitle" style="margin-left: 0;">
                起降场站
              </div>
              <div class="redLine" style="float: left;margin-top: -6px;"></div>
              <div style="width: 100%;height: 60px;display: flex;">
                <div class="occupy flex-space"
                  style="width: 40%;height: 100%;display: flex;flex-direction: column;margin-top: 8px;">
                  <div class="name" style="margin-left:0;width: 100%;text-align: left;">
                    空闲
                  </div>
                  <div class="num" style="text-align: left;margin-left: 5px;">
                      {{
                      this.facilitiesData.takeOffIdleNum != undefined
                        ? this.facilitiesData.takeOffIdleNum
                        : NaN
                    }}
                  </div>
                </div>
                <div class="emptyItem flex-space"
                  style="width: 60%;height: 100%;display: flex;flex-direction: column;margin-top: 8px;">
                  <div class="name" style="margin-left:0;width: 100%;text-align: left;">
                    占用
                  </div>
                  <div class="num" style="text-align: left;width: 100%;">
                      {{
                        this.facilitiesData.takeOffUseNum != undefined
                          ? this.facilitiesData.takeOffUseNum
                          : NaN
                      }}
                  </div>
                </div>
              </div>
            </div>
            <div class="rightTopBottom">
              <div class="rightTopTopTitle" style="text-align: right;">
                设备状态
              </div>
              <div class="redLine" style="float: right;margin-top: -6px;"></div>
              <div style="width: 100%;height:60px;display: flex;">
                <div class="occupy flex-space"
                  style="width: 60%;height: 100%;display: flex;flex-direction: column;margin-top: 8px;">
                  <div class="name" style="margin-left: 53px;">在线</div>
                  <div class="num">
                    <!--                  {{-->
                    <!--                    this.facilitiesData.equipmentOnlineNum != undefined-->
                    <!--                      ? this.facilitiesData.equipmentOnlineNum-->
                    <!--                      : NaN-->
                    <!--                  }}-->
                    70
                  </div>
                </div>
                <div class="emptyItem flex-space"
                  style="width: 40%;height: 100%;display: flex;flex-direction: column;margin-top: 8px;">
                  <div class="name">离线</div>
                  <div class="num">
                    <!--                  {{-->
                    <!--                    this.facilitiesData.equipmentOfflineNum != undefined-->
                    <!--                      ? this.facilitiesData.equipmentOfflineNum-->
                    <!--                      : NaN-->
                    <!--                  }}-->
                    8
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="closeRight" v-show="openRight" @click="openRight = false;openLeft = false">
      <img src="../../assets/img/2dmap/pop_close_open.png" alt=""/>
    </div>
    <div class="openRight" v-show="!openRight" @click="handleOpenRight">
      <img src="../../assets/img/2dmap/pop_close_open.png" alt=""/>
    </div> -->
    <div class="rightOpenBtns" v-show="openRight">
      <div class="rightBtn" @click="
        openRight = false;
      openLeft = false;
      ">
        <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/pop_close_open.png`)" alt="" />
      </div>
    </div>
    <div class="rightCloseBtns" v-show="!openRight">
      <div class="rightBtn" @click="
        openRight = true;
      openLeft = true;
      ">
        <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/pop_close_open.png`)" alt="" />
      </div>
    </div>
    <div class="rightContent" v-show="openRight">
      <div class="screenItem">
        <div class="title">
          <!--            <div class="jiantou"></div>-->
          <span> 飞行概览 </span>
        </div>
        <div class="screenItemContent">
           <div v-show="!allEyesModel" class="rightEyesHeader flyTop1">
            <div class="rightEyesHeaderItem" @click="chartType = 1; initChangeChart();">
              <div class="flyText">

                运行小时数
              </div>
              <div :class="chartType === 1 ? 'canChangeFigureActive' : 'canChangeFigure'">
                <!--                {{-->
                <!--                  this.planViewData.safeHours != undefined-->
                <!--                    ? this.planViewData.safeHours-->
                <!--                    : NaN-->
                <!--                }}-->

                3107
              </div>
            </div>
            <div class="rightEyesHeaderItem" @click="chartType = 2; initChangeChart();">
              <div class="flyText">
                运行架次
              </div>
              <div :class="chartType === 2 ? 'canChangeFigureActive' : 'canChangeFigure'">
                <!--                {{-->
                <!--                  this.planViewData.flySorties != undefined-->
                <!--                    ? this.planViewData.flySorties-->
                <!--                    : NaN-->
                <!--                }}-->
                6194
              </div>
            </div>
            <div class="rightEyesHeaderItem" @click="chartType = 3; initChangeChart();">
              <div class="flyText">
                运行里程
              </div>
              <div :class="chartType === 3 ? 'canChangeFigureActive' : 'canChangeFigure'">
                <!--                {{-->
                <!--                  this.planViewData.miles != undefined-->
                <!--                    ? this.planViewData.miles-->
                <!--                    : NaN-->
                <!--                }}-->
                22942
              </div>
            </div>
          </div>
          <div v-show="allEyesModel" class="rightEyesHeader">
            <div class="rightEyesHeaderItem" @click="chartType = 1; initChangeChart();">
              <div class="flyText">

                运行小时数
              </div>
              <div :class="chartType === 1 ? 'canChangeFigureActive' : 'canChangeFigure'">
                <!--                {{-->
                <!--                  this.planViewData.safeHours != undefined-->
                <!--                    ? this.planViewData.safeHours-->
                <!--                    : NaN-->
                <!--                }}-->

                3107
              </div>
            </div>
            <div class="rightEyesHeaderItem" @click="chartType = 2; initChangeChart();">
              <div class="flyText">
                运行架次
              </div>
              <div :class="chartType === 2 ? 'canChangeFigureActive' : 'canChangeFigure'">
                <!--                {{-->
                <!--                  this.planViewData.flySorties != undefined-->
                <!--                    ? this.planViewData.flySorties-->
                <!--                    : NaN-->
                <!--                }}-->
                6194
              </div>
            </div>
            <div class="rightEyesHeaderItem" @click="chartType = 3; initChangeChart();">
              <div class="flyText">
                运行里程
              </div>
              <div :class="chartType === 3 ? 'canChangeFigureActive' : 'canChangeFigure'">
                <!--                {{-->
                <!--                  this.planViewData.miles != undefined-->
                <!--                    ? this.planViewData.miles-->
                <!--                    : NaN-->
                <!--                }}-->
                22942
              </div>
            </div>
          </div>
          <div style="
              width: 100%;
              height: calc(100% - 50px);
              min-height: 170px;
              overflow: hidden;
            " id="flyDataCharts"></div>
        </div>
      </div>
      <div class="screenItem">
        <div class="title">
          <span> 飞行活动 </span>
        </div>
        <div class="screenItemContent">
          <div v-show="!allEyesModel" class="rightEyesHeader flyTop2">
            <div class="rightEyesHeaderItem">
              <div class="flyText">

                历史飞行
              </div>
              <div class="canChangeFigure">
                <!--                {{-->
                <!--                  this.planActivity.historyTimes != undefined-->
                <!--                    ? this.planActivity.historyTimes-->
                <!--                    : NaN-->
                <!--                }}-->
                6194
              </div>
            </div>
            <div class="rightEyesHeaderItem">
              <div class="flyText">
                当日飞行
              </div>
              <div class="canChangeFigure" style="padding-left: 2px;">
                <!--                {{-->
                <!--                  this.planActivity.todayTimes != undefined-->
                <!--                    ? this.planActivity.todayTimes-->
                <!--                    : NaN-->
                <!--                }}-->
                2
              </div>
            </div>
            <div class="rightEyesHeaderItem">
              <div class="flyText">
                当日待飞行
              </div>
              <div class="canChangeFigure" style="padding-left: 10px;">
                <!--                {{-->
                <!--                  this.planActivity.todayUnTimes != undefined-->
                <!--                    ? this.planActivity.todayUnTimes-->
                <!--                    : NaN-->
                <!--                }}-->
                2

              </div>
            </div>
          </div>
          <div v-show="allEyesModel" class="rightEyesHeader">
            <div class="rightEyesHeaderItem">
              <div class="flyText">

                历史飞行
              </div>
              <div class="canChangeFigure">
                <!--                {{-->
                <!--                  this.planActivity.historyTimes != undefined-->
                <!--                    ? this.planActivity.historyTimes-->
                <!--                    : NaN-->
                <!--                }}-->
                6194
              </div>
            </div>
            <div class="rightEyesHeaderItem">
              <div class="flyText">
                当日飞行
              </div>
              <div class="canChangeFigure" style="padding-left: 2px;">
                <!--                {{-->
                <!--                  this.planActivity.todayTimes != undefined-->
                <!--                    ? this.planActivity.todayTimes-->
                <!--                    : NaN-->
                <!--                }}-->
                2
              </div>
            </div>
            <div class="rightEyesHeaderItem">
              <div class="flyText">
                当日待飞行
              </div>
              <div class="canChangeFigure" style="padding-left: 10px;">
                <!--                {{-->
                <!--                  this.planActivity.todayUnTimes != undefined-->
                <!--                    ? this.planActivity.todayUnTimes-->
                <!--                    : NaN-->
                <!--                }}-->
                2

              </div>
            </div>
          </div>
          <div style="
              width: 100%;
              height: calc(100% - 50px);
              min-height: 170px;
              overflow: hidden;
            " id="flyActiveCharts"></div>
        </div>
      </div>
      <div class="screenItem">
        <div class="title">
          <span> 飞行器 </span>
        </div>
        <div class="screenItemContent">
          <div style="display: flex;">
            <div class="rightBottomTop flexCenter" style="margin-right: 9px">
              <div class="rightBottomTopContent" style="display: flex;width: 100%;">
                <!-- <div class="titleShuFenge" style="background: #ff8c4d"></div> -->
                <img :src="require(`../../assets/img/${allEyesModel ? '2dmap_eyes' : '2dmap'}/fei_xing_qi_zong_sshu.png`)"
                  alt="">
                <div class="titleBgL">
                  <div class="contentFigure ordinaryFigure">
                    <!--                    {{ this.aircraftData.totalNum }}-->
                    122
                  </div>
                  <div class="contentText ordinaryText">飞行器总数</div>
                </div>
              </div>
            </div>
            <div class="rightBottomTop flexCenter">
              <div class="rightBottomTopContent" style="display: flex;width: 100%;margin-left: 15px;">
                <!-- <div class="titleShuFenge" style="background: #ff5555"></div> -->
                <img :src="require(`../../assets/img/${allEyesModel ? '2dmap_eyes' : '2dmap'}/fei_xing_qi_zong_sshu.png`)"
                  alt="">
                <div class="titleBgR">
                  <div class="contentFigure ordinaryFigure">
                    {{ this.aircraftData.flyingNum + 2 }}
                  </div>
                  <div class="contentText ordinaryText">飞行中</div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: calc(100% - 108px)">
            <div class="levelWrap">
              <div class="RightBottomBottom" v-if="
                this.aircraftData.detail.length > 1 ||
                this.aircraftData.detail.length == 1
              ">
                <div class="shortShuFenge">1</div>
                <div class="rightBottomBottomText" style="border-bottom: 2px solid #00AEFF;">
                  {{
                    this.aircraftData.detail[0] &&
                    this.aircraftData.detail[0].owner
                  }}
                </div>
                <div class="processStyle">
                  <el-progress :text-inside="true" color="#00FFFF" :show-text="false" :percentage="this.aircraftData.detail[0] &&
                    this.aircraftData.detail[0].rate + 20
                    "></el-progress>
                </div>
                <div class="RightBottomBottomFigure">
                  {{
                    this.aircraftData.detail[0] &&
                    this.aircraftData.detail[0].num + 30
                  }}
                </div>
              </div>
              <div class="RightBottomBottom" v-if="
                this.aircraftData.detail.length > 2 ||
                this.aircraftData.detail.length == 2
              ">
                <div class="shortShuFenge">2</div>
                <div class="rightBottomBottomText" style="border-bottom: 2px solid #00FFFF;">
                  {{
                    this.aircraftData.detail[0] &&
                    this.aircraftData.detail[1].owner
                  }}
                </div>
                <div class="processStyle">
                  <el-progress :text-inside="true" color="#00FFFF" :show-text="false" :percentage="this.aircraftData.detail[0] &&
                    this.aircraftData.detail[1].rate + 15
                    "></el-progress>
                </div>
                <div class="RightBottomBottomFigure">
                  {{
                    this.aircraftData.detail[0] &&
                    this.aircraftData.detail[1].num + 20
                  }}
                </div>
              </div>
              <div class="RightBottomBottom" v-if="
                this.aircraftData.detail.length > 3 ||
                this.aircraftData.detail.length == 3
              ">
                <div class="shortShuFenge">3</div>
                <div class="rightBottomBottomText" style="border-bottom: 2px solid #00AEFF;">
                  {{
                    this.aircraftData.detail[0] &&
                    this.aircraftData.detail[2].owner
                  }}
                </div>
                <div class="processStyle">
                  <el-progress color="#00FFFF" :show-text="false" :text-inside="true" :percentage="this.aircraftData.detail[0] &&
                    this.aircraftData.detail[2].rate + 2
                    " status="exception"></el-progress>
                </div>
                <el-progress :text-inside="true" :percentage="50" status="exception"></el-progress>
                <div class="RightBottomBottomFigure">
                  {{
                    this.aircraftData.detail[0] &&
                    this.aircraftData.detail[2].num + 10
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="mapRef" id="airspace-container" style="width: 100%; height: 100%"></div>
    <div class="chooseArea">
      <el-select @change="handleProvChange(selectProvince)" v-model="selectProvince" placeholder="请选择省份">
        <el-option v-for="province in province" :key="province.code" :label="province.name"
          :value="province.code"></el-option>
      </el-select>
      <el-select @change="handleCiChange(selectCity)" v-model="selectCity" placeholder="请选择城市"
        :disabled="!selectProvince || selectProvince == 0">
        <el-option v-for="city in city" :key="city.code" :label="city.name" :value="city.code"></el-option>
      </el-select>
      <el-select @change="handleDisChange(selectDistrict)" v-model="selectDistrict" placeholder="请选择区/县"
        :disabled="!selectCity || selectProvince == 0">
        <el-option v-for="district in district" :key="district.code" :label="district.name"
          :value="district.code"></el-option>
      </el-select>
    </div>
    <div class="openAir" title="新增空域或航线" v-show="!open && !flyArea" @click="open = true">
      <img src="../../assets/img/2dmap/jiantou_shangzhankai.png" alt="" />
    </div>
    <div id="chooseAirspace" v-show="open">
      <div class="airspaceTitle">
        <el-tabs v-model="activeName" @tab-click="
          cancelDrawAll();
        cancelDraw();
        ">
          <el-tab-pane label="新增空域" name="airspace"></el-tab-pane>
          <el-tab-pane label="新增航线" name="airline"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="close" @click="close()">
        <img src="../../assets/img/2dmap/jiantou_xiashoulong.png" alt="" />
      </div>
      <div v-show="this.activeName === 'airspace'">
        <el-row>
          <el-radio-group v-model="addAirSpaseType" fill="#fee075" text-color="#fff" size="medium"
            @change="changeDrawType">
            <el-radio :label="1">手绘</el-radio>
            <el-radio :label="2">自动生成</el-radio>
          </el-radio-group>
        </el-row>

        <el-row>
          <!--        <div class="title"></div>-->
          <div class="radio">
            <div class="checkbox">
              <el-checkbox v-model="ploygonChecked" @change="handleCheckPloygon">
                多边形
              </el-checkbox>
              <el-checkbox v-model="circleChecked" @change="handleCheckcircle">
                圆形
              </el-checkbox>
            </div>
            <el-button v-show="this.addAirSpaseType === 2" size="small" class="preViewBtn" @click="handelPreview">预览
            </el-button>
          </div>
        </el-row>

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" label-position="left"
          class="demo-ruleForm">
          <el-row class="coordinateRow" v-if="addAirSpaseType === 2 && this.ploygonChecked">
            <el-form-item class="coordinate" v-for="(coordinate, index) in ruleForm.airSpaseCoordinateArr"
              :label="`坐标点 ${index + 1}`" :key="coordinate.key" :prop="`airSpaseCoordinateArr.${index}.value`"
              :rules="{ validator: validateCoordinates, trigger: 'blur' }">
              <el-input v-model="coordinate.value" placeholder="经度,纬度以逗号分隔">
                <template slot="suffix">
                  <el-button :disabled="ruleForm.airSpaseCoordinateArr.length === 1"
                    @click.prevent="removeCoordinate(coordinate)">删除
                  </el-button>
                  <el-button :disabled="ruleForm.airSpaseCoordinateArr.length > 16" @click="addCoordinate">新增
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-row>

          <el-row v-if="addAirSpaseType === 2 && this.circleChecked">
            <el-col>
              <el-form-item label="中心点" prop="center">
                <el-input v-model="ruleForm.center" type="text" placeholder="请填写中心点经纬度以逗号隔开">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="半径" prop="radius">
                <el-input v-model="ruleForm.radius" type="text" placeholder="请填写半径">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item class="select" label="空域类型" prop="type">
                <el-select v-model="ruleForm.type" placeholder="请选择空域类型">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item class="alarmtime" label="空域名称" prop="name">
                <el-input v-model="ruleForm.name" type="text" placeholder="请填写空域名称">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="alarmtime" label="底面高度" prop="bottomHeight">
                <el-input v-model="ruleForm.bottomHeight" type="text" placeholder="请填写底面高度">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item class="alarmtime" label="空域高度" prop="height">
                <el-input v-model="ruleForm.height" type="text" placeholder="请填写空域高度">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="alarmtime" label="申请单位" prop="institution">
                <el-input v-model="ruleForm.institution" type="text" placeholder="请填写申请单位">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="time" label="开始时间" prop="date1">
                <el-date-picker v-model="ruleForm.date1" type="datetime" placeholder="请选择时间"
                  :picker-options="disabledStartDate">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item class="time" label="结束时间" prop="date2">
                <el-date-picker v-model="ruleForm.date2" type="datetime" placeholder="请选择时间"
                  :picker-options="disabledEndDate">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="alarmtime" label="告警时间(分钟)" prop="minute">
                <el-input v-model="ruleForm.minute" type="text" placeholder="请填写时间">
                  <!-- <template slot="append">分钟</template> -->
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="alarmtime" label="面积(km²)" prop="area">
                <el-input v-model="ruleForm.area" type="text" placeholder="请填写面积">
                  <!-- <template slot="append">km²</template> -->
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item class="select" label="审批类型" prop="approvingType">
                <el-select v-model="ruleForm.approvingType" placeholder="请选择审批类型">
                  <el-option v-for="item in approvingTypeOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="alarmtime" label="审批单位" prop="approvingUnit">
                <el-input v-model="ruleForm.approvingUnit" type="text" placeholder="请填写审批单位">
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item class="note" label="备注" prop="note">
                <el-input v-model="ruleForm.note" :rows="1" type="textarea" placeholder="请填写备注">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item class="select" label="省份" :rules="[
                { required: true, trigger: 'change', message: '请选择省份' }
              ]" prop="selectedProvince">
                <el-select @change="handleProvinceChange" v-model="ruleForm.selectedProvince" placeholder="请选择省份">
                  <el-option v-for="province in provinces" :key="province.code" :label="province.name"
                    :value="province.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="alarmtime" label="城市" :rules="[
                { required: false, trigger: 'change', message: '请选择城市' }
              ]">
                <el-select @change="handleCityChange" v-model="ruleForm.selectedCity" placeholder="请选择城市"
                  :disabled="!ruleForm.selectedProvince" clearable>
                  <el-option v-for="city in cities" :key="city.code" :label="city.name" :value="city.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="note" label="区/县" :rules="[
                { required: false, trigger: 'change', message: '请选择区域' }
              ]">
                <el-select v-model="ruleForm.selectedDistrict" placeholder="请选择区/县" :disabled="!ruleForm.selectedCity"
                  clearable>
                  <el-option v-for="district in districts" :key="district.code" :label="district.name"
                    :value="district.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="footer">
            <el-col>
              <el-button class="cancel" @click="cancel()">取消</el-button>
              <el-button class="confirm" style="margin-left: 25px" @click="submitForm('ruleForm')"
                :disabled="!isButtonActive">确定
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-show="this.activeName === 'airline'">
        <el-row>
          <!--        <div class="title"></div>-->
          <div>
            <el-button size="small" class="preViewBtn" @click="handelDrawLine">绘制航线
            </el-button>

            <el-button v-show="chooseLine" size="small" class="preViewBtn" @click="cancelDraw">取消绘制
            </el-button>
            <div class="tooptip" v-show="chooseLine">
              提示：双击结束绘制航线
            </div>
          </div>
        </el-row>

        <el-form :model="ruleFormLine" :rules="rulesLine" ref="ruleFormLine" label-width="120px" label-position="right"
          class="demo-ruleForm">
          <el-row :gutter="50">
            <el-col :span="10" style="margin-left: 20px">
              <el-form-item class="alarmtime" label="航线名称" prop="name">
                <el-input v-model="ruleFormLine.name" type="text" placeholder="请填写航线名称">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" style="margin-left: 101px">
              <el-form-item class="alarmtime" label="海拔高(m)" prop="altitude" :rules="[
                {
                  required: true,
                  message: '请填写海拔高(m)',
                  trigger: 'blur'
                },
                { validator: this.validateNumber, trigger: 'blur' }
              ]">
                <el-input v-model="ruleFormLine.altitude" type="text" placeholder="请填写海拔高度">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="50">
            <el-col :span="10" style="margin-left: 20px">
              <el-form-item label="是否返航" prop="isback">
                <el-select v-model="ruleFormLine.isback" placeholder="请选择是否返航" popper-class="adminHomeSelect">
                  <el-option label="否" :value="0"></el-option>
                  <el-option label="是" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" style="margin-left: 101px">
              <el-form-item label="航线类型" prop="airLineType" :rules="[
                {
                  required: true,
                  trigger: 'blur',
                  message: '请选择航线类型'
                }
              ]">
                <el-select v-model="ruleFormLine.airLineType" placeholder="请选择航线类型" popper-class="adminHomeSelect">
                  <el-option v-for="item in airLineTypes" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="8">
              <el-form-item class="select" label="省份" :rules="[
                { required: true, trigger: 'change', message: '请选择省份' }
              ]" prop="selectedProvince">
                <el-select @change="handleProvinceChange" v-model="ruleFormLine.selectedProvince" placeholder="请选择省份">
                  <el-option v-for="province in provinces" :key="province.code" :label="province.name"
                    :value="province.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="alarmtime" label="城市" :rules="[
                { required: false, trigger: 'change', message: '请选择城市' }
              ]">
                <el-select @change="handleCityChange" v-model="ruleFormLine.selectedCity" placeholder="请选择城市" clearable
                  :disabled="!ruleFormLine.selectedProvince">
                  <el-option v-for="city in cities" :key="city.code" :label="city.name" :value="city.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item class="note" label="区/县" :rules="[
                { required: false, trigger: 'change', message: '请选择区域' }
              ]">
                <el-select v-model="ruleFormLine.selectedDistrict" placeholder="请选择区/县" clearable
                  :disabled="!ruleFormLine.selectedCity">
                  <el-option v-for="district in districts" :key="district.code" :label="district.name"
                    :value="district.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="footer">
            <el-col>
              <el-button class="cancel" @click="cancelLine()">取消</el-button>
              <el-button class="confirm" style="margin-left: 25px" @click="submitFormLine('ruleFormLine')"
                :disabled="!isButtonActive">确定
              </el-button>
            </el-col>
          </el-row>
          <!--        <el-form-item class="footer">-->
          <!--          <el-button size="small" class="cancel" @click="cancel()"></el-button>-->
          <!--          <el-button-->
          <!--            class="confirm"-->
          <!--            size="small"-->
          <!--            style="margin-left:25px"-->
          <!--            @click="submitForm('ruleForm')"-->
          <!--            :disabled="!isButtonActive"-->
          <!--          >-->
          <!--          </el-button-->
          <!--          >-->
          <!--        </el-form-item>-->
        </el-form>
      </div>
    </div>
    <div id="chooseAirspace" v-show="flyArea">
      <div class="airspaceTitle">修改空域数据</div>
      <div class="close" @click="close()">
        <img src="../../assets/img/2dmap/jiantou_xiashoulong.png" alt="" />
      </div>
      <el-form :model="airSpaceInfo" :rules="rules1" ref="airSpaceInfo" label-width="120px" label-position="left"
        class="demo-ruleForm">
        <el-col v-if="shapeType === 1" class="positionSet">
          <el-form-item label="中心点" prop="center">
            <el-input v-model="airSpaceInfo.center" type="text" placeholder="请填写中心点经纬度以逗号隔开">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="shapeType === 1" class="positionSet">
          <el-form-item label="半径" prop="radius">
            <el-input v-model="airSpaceInfo.radius" type="text" placeholder="请填写半径">
            </el-input>
          </el-form-item>
        </el-col>
        <el-row class="coordinateRow" v-if="shapeType === 0">
          <el-form-item class="coordinate" v-for="(coordinate, index) in airSpaceInfo.airSpaseCoordinateArr"
            :label="`坐标点 ${index + 1}`" :key="coordinate.key" :prop="`airSpaseCoordinateArr.${index}.value`"
            :rules="{ validator: validateCoordinates, trigger: 'blur' }">
            <el-input v-model="coordinate.value" placeholder="经度,纬度以逗号分隔">
              <template slot="suffix">
                <el-button :disabled="airSpaceInfo.airSpaseCoordinateArr.length === 1"
                  @click.prevent="removeCoordinateByedit(coordinate)">删除
                </el-button>
                <el-button :disabled="airSpaceInfo.airSpaseCoordinateArr.length > 16" @click="addCoordinateByedit">新增
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="8">
            <el-form-item class="select" label="空域类型" prop="type">
              <el-select v-model="airSpaceInfo.type" placeholder="请选择空域类型">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item class="alarmtime" label="空域名称" prop="name">
              <el-input v-model="airSpaceInfo.name" type="text" placeholder="请填写空域名称">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="alarmtime" label="底面高度" prop="bottomHeight">
              <el-input v-model="airSpaceInfo.bottomHeight" type="text" placeholder="请填写底面高度">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="50">
          <el-col :span="8">
            <el-form-item class="alarmtime" label="高度" prop="height">
              <el-input v-model="airSpaceInfo.height" type="text" placeholder="请填写高度">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="alarmtime" label="申请单位" prop="institution">
              <el-input v-model="airSpaceInfo.institution" type="text" placeholder="请填写申请单位">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="time" label="开始时间" prop="date1">
              <el-date-picker :picker-options="disabledStartDateOne" v-model="airSpaceInfo.date1" type="datetime"
                placeholder="请选择时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="8">
            <el-form-item class="time" label="结束时间" prop="date2">
              <el-date-picker v-model="airSpaceInfo.date2" :picker-options="disabledEndDateOne" type="datetime"
                placeholder="请选择时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="alarmtime" label="告警时间(分钟)" prop="minute">
              <el-input v-model="airSpaceInfo.minute" type="text" placeholder="请填写时间">
                <!-- <template slot="append">分钟</template> -->
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="alarmtime" label="面积(km²)" prop="area">
              <el-input v-model="airSpaceInfo.area" type="text" placeholder="请填写面积">
                <!-- <template slot="append">km²</template> -->
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="8">
            <el-form-item class="select" label="审批类型" prop="approvingType">
              <el-select v-model="airSpaceInfo.approvingType" placeholder="请选择审批类型">
                <el-option v-for="item in approvingTypeOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="alarmtime" label="审批单位" prop="approvingUnit">
              <el-input v-model="airSpaceInfo.approvingUnit" type="text" placeholder="请填写审批单位">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="note" label="备注" prop="note">
              <el-input v-model="airSpaceInfo.note" :rows="1" type="textarea" placeholder="请填写备注">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="8">
            <el-form-item class="select" label="省份" :rules="[
              { required: true, trigger: 'change', message: '请选择省份' }
            ]" prop="selectedProvince">
              <el-select @change="handleProvinceChange" v-model="airSpaceInfo.selectedProvince" placeholder="请选择省份">
                <el-option v-for="province in provinces" :key="province.code" :label="province.name"
                  :value="province.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="alarmtime" label="城市" :rules="[
              { required: false, trigger: 'change', message: '请选择城市' }
            ]" prop="selectedCity">
              <el-select @change="handleCityChange" v-model="airSpaceInfo.selectedCity" placeholder="请选择城市" clearable
                :disabled="!airSpaceInfo.selectedProvince">
                <el-option v-for="city in cities" :key="city.code" :label="city.name" :value="city.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item class="note" label="区/县" :rules="[
              { required: false, trigger: 'change', message: '请选择区域' }
            ]">
              <el-select v-model="airSpaceInfo.selectedDistrict" placeholder="请选择区/县" clearable
                :disabled="!airSpaceInfo.selectedCity">
                <el-option v-for="district in districts" :key="district.code" :label="district.name"
                  :value="district.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="footer">
          <el-col>
            <el-button class="delete" @click="deleteEdit()">删除</el-button>
            <el-button class="modify" style="margin-left: 25px" @click="submit('airSpaceInfo')"
              :disabled="!isButtonActive">确认修改
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div :class="openRight ? 'changeWithOpen' : 'changeAirSpace'">
      <!-- 右侧 -->
      <div class="airSpaceBtnOne">
        <div title="空域" class="chooseBtn" :class="airSpaceChecked ? 'active' : ''" @click="
          airSpaceChecked = !airSpaceChecked;
        area = !area;
        ">
          <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${airSpaceChecked ? 'kong_yu_click' : 'kong_yu_normal'
            }.png`)
            " alt="" />
        </div>
        <div title="设备" class="chooseBtn" :class="shibeiChecked ? 'active' : ''" @click="
          shibeiChecked = !shibeiChecked;
        equip = !equip;
        ">
          <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${shibeiChecked ? 'she_bei_click' : 'she_bei_normal'
            }.png`)
            " alt="" />
        </div>
        <div title="航线/航点" class="chooseBtn" :class="airPointLineChecked ? 'active' : ''" @click="
          airPointLineChecked = !airPointLineChecked;
        airPointLine = !airPointLine;
        ">
          <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${airPointLineChecked ? 'fei_xing_click' : 'fei_xing_normal'
            }.png`)
            " alt="" />
        </div>
        <div title="地图要素                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  " class="chooseBtn" :class="airPointLineChecked ? 'active' : ''" @click="
          mapElementsChecked = !mapElementsChecked;
          ">
          <img :src="require(`../../assets/img/${allEyesModel ? '2dmap_eyes' : '2dmap'}/${mapElementsChecked ? 'di_tu_yao_su_click' : 'di_tu_yao_su_normal'
            }.png`)
            " alt="" />
        </div>
      </div>
    </div>
    <div class="levelOneBtns" :style="{ right: openRight ? '370px' : '12px' }">
      <!--      <div class="airSpaceBtn" style="width: 100%;height: 100%;">-->
      <div title="热力图" class="chooseBtn" @click="
        relituChecked = !relituChecked;
      addHot();
      ">
        <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/${relituChecked ? 'ren_kou_mi_du_click' : 'ren_kou_mi_du_normal'
          }.png`)
          " alt="" />
      </div>
      <div title="返回首页" class="chooseBtn" @click="handleBackHome" v-show="!isBigScreen">
        <img :src="require(`../../assets/img/${this.allEyesModel ? '2dmap_eyes' : '2dmap'}/home_page.png`)" alt="" />
      </div>
    </div>
    <div :class="openRight ? 'changeWithOpen1' : 'changeAirSpace1'">
      <!-- 右侧 -->
      <div class="airSpaceBtn" style="width: 100%;height: 100%;">
        <div v-show="area" class="area">
          <div class="chooseBtn" :class="electronicFenceChecked ? 'Active' : 'noActive'">
            <!-- <img
              :src="
                require(`../../assets/img/2dmap/${
                  electronicFenceChecked
                    ? 'dian_zi_wei_lan_click'
                    : 'dian_zi_wei_lan'
                }.png`)
              "
              alt=""
            /> -->
            <div @click="
              electronicFenceChecked = !electronicFenceChecked;
            airSpace();
            ">
              电子围栏
            </div>
          </div>
          <div class="chooseBtn" :class="noflyChecked ? 'Active' : 'noActive'">
            <!-- <img
              :src="
                require(`../../assets/img/2dmap/${
                  noflyChecked ? 'jinfeiqu-click' : 'jinfeiqu'
                }.png`)
              "
              alt=""
            /> -->
            <div @click="
              noflyChecked = !noflyChecked;
            airSpace();
            ">
              禁飞区
            </div>
          </div>

          <div class="chooseBtn" :class="canflyChecked ? 'Active' : 'noActive'" @click="
            canflyChecked = !canflyChecked;
          airSpace();
          ">
            <!-- <img
              :src="
                require(`../../assets/img/2dmap/${
                  canflyChecked ? 'shifeiqu-click' : 'shifeiqu'
                }.png`)
              "
              alt=""
            /> -->
            <div>适飞区</div>
          </div>
          <div class="chooseBtn" :class="limitChecked ? 'Active' : 'noActive'">
            <!-- <img
              :src="
                require(`../../assets/img/2dmap/${
                  limitChecked ? 'shouxianqu-click' : 'shouxianqu'
                }.png`)
              "
              alt=""
            /> -->
            <div @click="
              limitChecked = !limitChecked;
            airSpace();
            ">
              受限区
            </div>
          </div>
          <div class="changeWithOpenXianArea"></div>
        </div>
        <div v-show="equip" class="equip">
          <div class="chooseBtn" :class="showADSB ? 'Active' : 'noActive'">
            <span class="point monitorPoint"> </span>
            <div @click="changeADSBEquipment">ADSB侦察</div>
          </div>
          <div class="chooseBtn" :class="showOneRadar ? 'Active' : 'noActive'">
            <span class="point monitorPoint"> </span>
            <div @click="changeOneRadarEquipment">一次雷达</div>
          </div>
          <div class="chooseBtn" :class="isDisplayCountermeasureEquipment ? 'Active' : 'noActive'">
            <span class="point countermeasuwrePoint"> </span>
            <div @click="changeCountermeasureEquipment">侦测设备</div>
          </div>
          <div class="chooseBtn" :class="isDisplayWeatherEquipment ? 'Active' : 'noActive'">
            <span class="point weatherPoint"> </span>
            <div @click="changeWeatherEquipment">气象设备</div>
          </div>
          <div class="chooseBtn" :class="isDisplayMonitorEquipment ? 'Active' : 'noActive'">
            <span class="point videoPoint"> </span>
            <div @click="changeMonitorEquipment">视频设备</div>
          </div>
          <div class="chooseBtn" :class="isDisplayNavigationEquipment ? 'Active' : 'noActive'">
            <span class="point navigationPoint"> </span>
            <div @click="changeNavigationEquipment">导航设备</div>
          </div>
          <div class="chooseBtn" :class="isDisplayCommunicationEquipment ? 'Active' : 'noActive'">
            <span class="point communicationPoint"> </span>
            <div @click="changeCommunicationEquipment">通信设备</div>
          </div>
          <div class='changeWithOpenXianEquip'>

          </div>
        </div>
        <div v-show="airPointLine" class="airPointLine">
          <div class="chooseBtn" :class="showNormalairPort ? 'Active' : 'noActive'">
            <div @click="debouncedChangeormalAirPot()">航点</div>
          </div>
          <div class="chooseBtn" :class="showairPort ? 'Active' : 'noActive'">
            <div @click="debouncedChangeAirPot()">起降点</div>
          </div>
          <div class="chooseBtn" :class="showDubuleLine ? 'Active' : 'noActive'">
            <div @click="debouncedChangeLine()">切换航线</div>
          </div>
          <div class="chooseBtn" :class="showAirLineName ? 'Active' : 'noActive'">
            <div @click="changeAirLineName">航线名</div>
          </div>
          <div class="changeWithOpenXianAirPointLine"></div>
        </div>
        <div v-show="mapElementsChecked" class="mapElements">
          <div class="chooseBtn" :class="showRoadNetwork ? 'Active' : 'noActive'">
            <div @click="
              handelShowRoadNetwork
            ">路网
            </div>
          </div>
          <div class="chooseBtn" :class="showGreenPart ? 'Active' : 'noActive'">
            <div @click="
              handelShowGreenPart
            ">绿地
            </div>
          </div>
          <div class="chooseBtn" :class="showRiver ? 'Active' : 'noActive'">
            <div @click="
              handelShowRiver
            ">水系
            </div>
          </div>
          <div class='changeWithOpenMapElements'>

          </div>
        </div>
      </div>
    </div>
    <div :class="openRight ? 'changeWithOpenBottom' : 'changeAirSpaceBottom'">
      <!--            <div class="backHome" @click="handleBackHome">-->
      <!--              <div class="img"></div>-->
      <!--              <span>返回首页</span>-->
      <!--            </div>-->
      <div class="situationMapBtns">
        <div style="margin-right: 5px;" class="situationBtn" @click="clickRoad()">
          <img :src="require(`../../assets/img/${allEyesModel ? '2dmap_eyes' : '2dmap'}/${clickroad ? 'luwangtu_click' : 'luwangtu'
            }.png`)
            " alt="" />
        </div>
        <div class="situationBtn" @click="clickStar()">
          <img :src="require(`../../assets/img/${allEyesModel ? '2dmap_eyes' : '2dmap'}/${clickstar ? 'weixingtu_click' : 'weixingtu'
            }.png`)
            " alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw";
import "leaflet-geometryutil";
import "leaflet-draw/dist/leaflet.draw.css";
import echarts from "echarts";
import {
  wgs84ToGcj02,
  gcj02ToWgs84
} from "../../assets/js/map/ConverseLngAndLa";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/leaflet.markercluster.js";
import _ from "lodash";
import jsonData from "../../assets/js/population.json";
// import shangHaigeoJsonData from '../../assets/provinceJson/shanghai.geoJson';
import luwangGeoJson from "../../assets/provinceJson/luwang.geojson";
import greenPartGeoJsont from "../../assets/provinceJson/greenPart.geojson";
import riverGeoJson from "../../assets/provinceJson/river.geojson";
export default {
  name: "MunicipalLevelData",
  props: {
    ws: {
      type: WebSocket,
      default: null
    },
    //是否护眼模式
    isStyleApplied: {
      type: Boolean,
      default: true
    },
    //是否是大屏
    isBigScreen: {
      type: Boolean,
      default: false
    },
    //大屏是否显示护眼模式
    isEyeshield: {
      type: Boolean,
      default: true
    },
     //大屏ws
    wsBigScreen: {
      type: WebSocket,
      default: null
    }
  },
  data() {
    const validateHeight = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请填写高度"));
      }
      const num = parseFloat(value);
      if (isNaN(num) || num <= 0) {
        callback(new Error("空域高度必须为大于 0 的数字"));
      } else {
        callback();
      }
    };
    const validateBottomHeight = (rule, value, callback) => {
      if (!value && value !== 0) {
        return callback(new Error("请填写底面高度"));
      }
      const num = parseFloat(value);
      if (isNaN(num) || num < 0) {
        callback(new Error("底面高度必须为大于等于 0 的数字"));
      } else {
        callback();
      }
    };
    return {
      roadNetworkObj:null,
      greenPartObj:null,
      riverObj:null,
      showRoadNetwork: false,
      showGreenPart: false,
      showRiver: false,
      mapElementsChecked: false,
      regionCode: '',//查询空域带的省市区code
      showAirLineName: true,
      airSpaceChooseId: null,
      cityLayer: null,
      maxAirSpaceItem: {
        name: null,
        rate: 0
      },
      airSpaceChecked: true,
      shibeiChecked: false,
      populationChecked: false,
      airPointLineChecked: false,
      area: true,
      equip: false,
      population: false,
      airPointLine: false,
      showairPort: true, //显示隐藏起降点
      showNormalairPort: false, //显示隐藏普通航点
      showDubuleLine: false,
      province: [],
      city: [],
      district: [],
      selectProvince: "",
      selectCity: "",
      selectDistrict: "",
      provinces: [],
      cities: [],
      districts: [],
      selectedProvince: "",
      selectedCity: "",
      selectedDistrict: "",
      chooseLine: false,
      activeName: "airspace",
      startNoticeTimer: null, //通知定时器
      isDisplayCommunicationEquipment: false, //是否展示通信设备
      isDisplayMonitorEquipment: false, //是否展示监视设备
      isDisplayNavigationEquipment: false, //是否展示导航设备
      isDisplayWeatherEquipment: false, //是否展示气象设备
      isDisplayCountermeasureEquipment: false, //是否展示反制设备
      showADSB: false, //是否展示ADSB设备
      showOneRadar: false, //是否展示一次雷达设备
      communicationEquipmentData: [], //通信设备数据
      monitorEquipmentData: [], //监视设备数据
      navigationEquipmentData: [], //导航设备数据
      weatherEquipmentData: [], //气象设备数据
      countermeasureEquipmentData: [], //反制设备数据
      ADSBEquipmentData: [], //ADSB设备数据
      oneRadarEquipmentData: [], //一次雷达设备数据
      ADSBEquipmentTag: [], //ADSB设备图标
      oneRadarEquipmentTag: [], //一次雷达设备图标
      communicationEquipmentTag: [], //通信设备图标
      monitorEquipmentTag: [], //监视设备图标
      navigationEquipmentTag: [], //导航设备图标
      weatherEquipmentTag: [], //气象设备图标
      countermeasureEquipmentTag: [], //反制设备图标
      chartType: 1, //左侧折线图切换1.运行小时数2.运行架次3.运行里程
      openLeft: true, //左侧开关
      openRight: true, //右侧开关
      map: null,
      // mapcenter: [24.9402, 118.1806],//南安
      // mapcenter: [25.20249487751626, 118.44143629074098],//南安九都镇
      mapcenter: [31.2995549, 121.4511], //上海市静安
      // mapcenter: [34.34,108.80], //西咸新区
      // mapcenter: [32.06, 118.8],//南京
      open: false,
      isButtonActive: true, // 控制按钮是否可点击
      activeLayer: 0, //目前的图层
      clickstar: true,
      clickroad: false,
      drawControl: null, //空域选择类型控件
      drawnItems: null,
      ploygonChecked: false, //选择多边形
      circleChecked: false, //选择圆形
      noflyChecked: true, //选择禁飞区
      canflyChecked: true, //选择适飞区
      limitChecked: true, //选择受限区
      relituChecked: false, //选择热力图
      electronicFenceChecked: true, //选择电子围栏
      noflyAirSpaces: [], //禁飞空域
      canflyAirSpaces: [], //适飞空域
      limitAirSpaces: [], //受限空域
      latlngs: [], //选择空域多边形的点
      shapeType: 0, //0多边形，1圆
      //所有数据
      airSpaces: [], //所有空域
      //圆
      center: null,
      radius: 0,
      options: [
        {
          value: 0,
          label: "禁飞区"
        },
        {
          value: 1,
          label: "电子围栏"
        },
        {
          value: 3,
          label: "适飞区"
        },
        {
          value: 4,
          label: "受限区"
        },
        {
          value: 11,
          label: "管制空域"
        },
        {
          value: 21,
          label: "监视空域"
        }
      ],
      approvingTypeOptions: [
        {
          value: 1,
          label: "军方"
        },
        {
          value: 2,
          label: "政府"
        }
      ],
      ruleForm: {
        approvingUnit: "",
        approvingType: "",
        type: "",
        height: "",
        bottomHeight: "",
        institution: "",
        name: "",
        date1: "",
        date2: "",
        minute: null,
        area: "",
        note: "",
        airspacePointArry: "",
        airSpaseCoordinateArr: [{ value: "" }],
        center: "",
        radius: "",
        selectedDistrict: '',
        selectedCity: '',
        selectedProvince: ''
      },
      ruleFormLine: {
        localId: "",
        name: "",
        altitude: "",
        airLineType: "",
        airpointlist: [],
        isback: 0,//默认否
        selectedDistrict: '',
        selectedCity: '',
        selectedProvince: ''
      },
      airLineTypes: [
        { id: 0, name: "观光" },
        { id: 1, name: "巡检" },
        { id: 2, name: "物流" },
        { id: 3, name: "应急" }
      ],
      airLineType: "",
      airSpaceInfo: {
        type: "",
        height: "",
        bottomHeight: "",
        institution: "",
        approvingUnit: "",
        approvingType: "",
        name: "",
        date1: "",
        date2: "",
        minute: "",
        area: "",
        note: "",
        airspacePointArry: "",
        airSpaseCoordinateArr: [{ value: "" }],
        center: "",
        radius: "",
        id: null,
        selectedDistrict: '',
        selectedCity: '',
        selectedProvince: ''
      },
      originLayer:
        "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}",
      roadUrlTemplate:
        "https://wprd01.is.autonavi.com/appmaptile?langzh_cn&size=1&scale=1&style=8{ltype}&x={x}&y={y}&z={z}",
      satelliteUrlTemplate:
        "https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}",
      rules: {
        airspacePointArry: [
          {
            validator: function (rule, value, callback) {
              if (!value) {
                callback(new Error("请输入空域经纬度组"));
              } else if (
                value.split(";").length < 3 ||
                (value.split(";").length === 3 &&
                  value.split(";")[2].length < 3)
              ) {
                callback(new Error("空域数组至少为三组"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        type: [
          { required: true, message: "请选择空域类型", trigger: "change" }
        ],
        // institution: [
        //   { required: true, message: "请填写申请单位", trigger: "blur" }
        // ],
        name: [{ required: true, message: "请填写空域名称", trigger: "blur" }],
        height: [
          { required: true, validator: validateHeight, trigger: "blur" }
        ],
        bottomHeight: [
          { required: true, validator: validateBottomHeight, trigger: "blur" }
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "blur"
          }
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "blur"
          }
        ],
        minute: [
          { validator: this.validateNumber, trigger: "blur", required: true }
        ],
        area: [
          {
            validator: this.validateDoubleNumber,
            trigger: "blur",
            required: false
          }
        ],
        center: [
          {
            validator: this.validateCoordinates,
            trigger: "blur",
            required: true
          }
        ],
        radius: [{ required: true, message: "请填写半径", trigger: "blur" }],
        note: [{ validator: this.validateNote, trigger: "blur" }],
        approvingType: [
          { required: true, message: "请选择审批类型", trigger: "change" }
        ],
        approvingUnit: [
          { required: true, message: "请填写审批单位", trigger: "blur" }
        ],
        selectedProvince: [
          { required: true, message: "请选择省份", trigger: "blur" }
        ]
      },
      rulesLine: {
        // institution: [
        //   { required: true, message: "请填写申请单位", trigger: "blur" }
        // ],
        name: [{ required: true, message: "请填写航线名称", trigger: "blur" }],
        selectedProvince: [
          { required: true, message: "请选择省份", trigger: "blur" }
        ]
      },
      rules1: {
        airspacePointArry: [
          {
            validator: function (rule, value, callback) {
              if (!value) {
                callback(new Error("请输入空域经纬度组"));
              } else if (
                value.split(";").length < 3 ||
                (value.split(";").length === 3 &&
                  value.split(";")[2].length < 3)
              ) {
                callback(new Error("空域数组至少为三组"));
                d;
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        type: [
          { required: true, message: "请选择空域类型", trigger: "change" }
        ],
        name: [{ required: true, message: "请填写空域名称", trigger: "blur" }],
        height: [
          { required: true, validator: validateHeight, trigger: "blur" }
        ],
        bottomHeight: [
          { required: true, validator: validateBottomHeight, trigger: "blur" }
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "blur"
          }
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "blur"
          }
        ],
        minute: [
          { validator: this.validateNumber, trigger: "blur", required: true }
        ],
        area: [
          {
            validator: this.validateDoubleNumber,
            trigger: "blur",
            required: false
          }
        ],
        center: [
          {
            validator: this.validateCoordinates,
            trigger: "blur",
            required: true
          }
        ],
        radius: [{ required: true, message: "请填写半径", trigger: "blur" }],
        approvingType: [
          { required: true, message: "请选择审批类型", trigger: "change" }
        ],
        approvingUnit: [
          { required: true, message: "请填写审批单位", trigger: "blur" }
        ],
        note: [{ validator: this.validateNote, trigger: "blur" }],
        selectedProvince: [
          { required: true, message: "请选择省份", trigger: "blur" }
        ]
      },
      flyArea: false,
      planLines: [], //所有计划航线
      positionLines: null, //定位的航线
      positRoadWhite: null, //定位航线的白底
      planlineWhite: [], //航线白底
      runRoadWhites: [], //航线白底
      airLinePositions: [], //所有当前定位航线的航点
      airLinePorts: [], //所有计划航线的（航点）
      takeOffLandPoints: [], // 起降点（包含临时）
      normalPoints: [], // 普通航点
      airPorts: [], //所有航点（包含起降点）
      addAirSpaseType: 1, //新建空域类型 1手绘 2.自动生成
      addAirLineType: 1, //新建航线类型 1手绘 2.自动生成
      autoAirSpase: null,
      myChart1: null,
      myChart2: null,
      myChart3: null,
      myChart4: null,
      routeData: [], //空域统计数据
      routeOriginData: [], //空域统计原始数据
      AirSpaceOccupancyRateData: [], //空域占比数据
      facilitiesData: {}, //地面基础设施数据
      planViewData: {}, //飞行概览数据
      planActivity: {}, //飞行活动数据
      aircraftData: { detail: [] }, //飞行器数据
      noticeData: [], //公告内容
      latlngsline: [], //折线坐标
      provinceCode: ""
    };
  },
  computed: {
    uBtnPermissionList() {
      return this.getPageBtnRole("municipalLevelData") || [];
    },
    // 时间选择器限制 开始时间小于结束时间
    disabledStartDate() {
      //选择的日期
      let curDate = this.$moment(this.ruleForm.date1).format("YYYY-MM-DD");
      if (this.ruleForm.date2) {
        //最大日期
        let maxDate = this.$moment(this.ruleForm.date2).format("YYYY-MM-DD");
        // 如果选择的日期为最大日期，则设置为最大日期的时分秒
        let str = "";
        if (curDate == maxDate) {
          str = this.$moment(this.ruleForm.date2).format("HH:mm:ss");
        } else {
          str = "23:59:59";
        }
        return {
          disabledDate: time => {
            return time.getTime() > this.ruleForm.date2;
          },
          selectableRange: "00:00:00 - " + str
        };
      } else {
        return {
          disabledDate: () => {
            return false;
          }
        };
      }
    },
    disabledEndDate() {
      //选择的日期
      let curDate = this.$moment(this.ruleForm.date2).format("YYYY-MM-DD");

      if (this.ruleForm.date1) {
        //最小日期
        let minDate = this.$moment(this.ruleForm.date1).format("YYYY-MM-DD");
        //前推一天，防止当天日期无法选择
        let preTime = this.ruleForm.date1 - 24 * 3600000;
        // 如果选择的日期为最小日期，则设置为最小日期的时分秒
        let str = "";
        if (curDate == minDate) {
          str = this.$moment(this.ruleForm.date1).format("HH:mm:ss");
        } else {
          str = "00:00:00";
        }
        return {
          disabledDate: time => {
            return time.getTime() < preTime;
          },
          selectableRange: str + " - 23:59:59"
        };
      } else {
        return {
          disabledDate: () => {
            return false;
          }
        };
      }
    },
    disabledStartDateOne() {
      //选择的日期
      let curDate = this.$moment(this.airSpaceInfo.date1).format("YYYY-MM-DD");
      if (this.airSpaceInfo.date2) {
        //最大日期
        let maxDate = this.$moment(this.airSpaceInfo.date2).format(
          "YYYY-MM-DD"
        );
        // 如果选择的日期为最大日期，则设置为最大日期的时分秒
        let str = "";
        if (curDate == maxDate) {
          str = this.$moment(this.airSpaceInfo.date2).format("HH:mm:ss");
        } else {
          str = "23:59:59";
        }
        return {
          disabledDate: time => {
            return time.getTime() > this.airSpaceInfo.date2;
          },
          selectableRange: "00:00:00 - " + str
        };
      } else {
        return {
          disabledDate: () => {
            return false;
          }
        };
      }
    },
    disabledEndDateOne() {
      //选择的日期
      let curDate = this.$moment(this.airSpaceInfo.date2).format("YYYY-MM-DD");

      if (this.airSpaceInfo.date1) {
        //最小日期
        let minDate = this.$moment(this.airSpaceInfo.date1).format(
          "YYYY-MM-DD"
        );
        //前推一天，防止当天日期无法选择
        let preTime = this.airSpaceInfo.date1 - 24 * 3600000;
        // 如果选择的日期为最小日期，则设置为最小日期的时分秒
        let str = "";
        if (curDate == minDate) {
          str = this.$moment(this.airSpaceInfo.date1).format("HH:mm:ss");
        } else {
          str = "00:00:00";
        }
        return {
          disabledDate: time => {
            return time.getTime() < preTime;
          },
          selectableRange: str + " - 23:59:59"
        };
      } else {
        return {
          disabledDate: () => {
            return false;
          }
        };
      }
    },
    allEyesModel() {
      return this.isBigScreen ? this.isEyeshield : this.isStyleApplied
    }
  },
  watch: {
     open: {
      handler(newVal, oldVal) {
        if (!this.open) {
          this.chooseLine = false
          this.ploygonChecked = false
          this.circleChecked = false
          //取消绘制
          const cancelDraw = document.querySelector('ul.leaflet-draw-actions a[title="Cancel drawing"]');;
          if (cancelDraw) {
            cancelDraw.click();
          }
        }
      }
    },
    ws: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getLastStatus()
        }
      }
    },
    "ruleForm.airSpaseCoordinateArr": {
      handler(newAddress) {
        if (this.ruleForm.airSpaseCoordinateArr.length >= 3) {
          this.ruleForm.area = Number(
            this.calculateArea(
              this.formAirSpaseCoordinateArrData(
                this.ruleForm.airSpaseCoordinateArr
              ),
              "ploygon"
            )
          );
        }
      },
      deep: true // 深度监听
    },
    "airSpaceInfo.airSpaseCoordinateArr": {
      handler() {
        if (this.airSpaceInfo.airSpaseCoordinateArr.length >= 3) {
          this.airSpaceInfo.area = Number(
            this.calculateArea(
              this.formAirSpaseCoordinateArrData(
                this.airSpaceInfo.airSpaseCoordinateArr
              ),
              "ploygon"
            )
          );
        }
      },
      deep: true // 深度监听
    },
    "ruleForm.center": {
      handler(newAddress) {
        if (this.ruleForm.radius && this.ruleForm.center) {
          this.ruleForm.area = this.calculateArea();
        }
      },
      deep: true // 深度监听
    },
    "ruleForm.radius": {
      handler(newAddress) {
        if (this.ruleForm.radius && this.ruleForm.center) {
          this.ruleForm.area = this.calculateArea(this.ruleForm.radius);
        }
      },
      deep: true // 深度监听
    },
    "airSpaceInfo.center": {
      handler(newAddress) {
        if (this.airSpaceInfo.radius && this.airSpaceInfo.center) {
          this.airSpaceInfo.area = this.calculateArea(this.airSpaceInfo.radius);
        }
      },
      deep: true // 深度监听
    },
    "airSpaceInfo.radius": {
      handler(newAddress) {
        if (this.airSpaceInfo.radius && this.airSpaceInfo.center) {
          this.airSpaceInfo.area = this.calculateArea(this.airSpaceInfo.radius);
        }
      },
      deep: true // 深度监听
    },
    routeData: {
      handler(newAddress) {
        this.maxAirSpaceItem = newAddress.reduce((prev, current) => {
          return prev.value > current.value ? prev : current;
        });
      }
    },
    isStyleApplied: {
      handler(newVal, oldVal) {
        this.updateChartStyle();
        if (this.map) {
          if (this.cityLayer) {
            this.cityLayer.setStyle({
              color: this.isStyleApplied
                ? "rgba(214, 211, 241, 1)"
                : "rgba(255, 254, 190, 1)",
              weight: 2,
              fillColor: this.isStyleApplied
                ? "rgba(219, 217, 255, 0.48)"
                : "rgba(255, 246, 141, 0.48)",
              fillOpacity: 0.48
            });
          }
          this.airSpaces.map(v => {
            v.setStyle({
              color:
                this.allEyesModel ? 'rgba(214,211,241,0.48)' : v.myCustomType === 0 || v.myCustomType === 1
                  ? "#e21838"
                  : v.myCustomType === 3
                    ? "#21f48e"
                    : v.myCustomType === 4 ||
                      v.myCustomType === 21
                      ? "yellow"
                      : v.myCustomType === 11
                        ? "orange"
                        : null, //填充颜色, //边框颜色#aa0000
              fillColor:
                this.allEyesModel ? 'rgba(214,211,241,0.48)' : v.myCustomType === 0 || v.myCustomType === 1
                  ? "rgba(226,24,56,0.48)"
                  : v.myCustomType === 3
                    ? "rgba(32,180,67,0.48)"
                    : v.myCustomType === 4 ||
                      v.myCustomType === 21
                      ? "rgba(252,255,44,0.48)"
                      : v.myCustomType === 11
                        ? "rgba(248,168,34,0.48)"
                        : null, //填充颜色
              fillOpacity: 1, //填充透明度
              weight: 1 //边框宽度
            });
          })
        }
      }
    },
    isEyeshield: {
      handler(newVal, oldVal) {
        this.updateChartStyle();
        if (this.map) {
          this.updateTheme()
          if (this.cityLayer) {
            this.cityLayer.setStyle({
              color: this.isEyeshield
                ? "rgba(214, 211, 241, 1)"
                : "rgba(255, 254, 190, 1)",
              weight: 2,
              fillColor: this.isEyeshield
                ? "rgba(219, 217, 255, 0.48)"
                : "rgba(255, 246, 141, 0.48)",
              fillOpacity: 0.48
            });
          }
          this.airSpaces.map(v => {
            v.setStyle({
              color:
                this.allEyesModel ? 'rgba(214,211,241,0.48)' : v.myCustomType === 0 || v.myCustomType === 1
                  ? "#e21838"
                  : v.myCustomType === 3
                    ? "#21f48e"
                    : v.myCustomType === 4 ||
                      v.myCustomType === 21
                      ? "yellow"
                      : v.myCustomType === 11
                        ? "orange"
                        : null, //填充颜色, //边框颜色#aa0000
              fillColor:
                this.allEyesModel ? 'rgba(214,211,241,0.48)' : v.myCustomType === 0 || v.myCustomType === 1
                  ? "rgba(226,24,56,0.48)"
                  : v.myCustomType === 3
                    ? "rgba(32,180,67,0.48)"
                    : v.myCustomType === 4 ||
                      v.myCustomType === 21
                      ? "rgba(252,255,44,0.48)"
                      : v.myCustomType === 11
                        ? "rgba(248,168,34,0.48)"
                        : null, //填充颜色
              fillOpacity: 1, //填充透明度
              weight: 1 //边框宽度
            });
          })
        }
      }
    },
    flyArea: {
      handler(newVal, oldVal) {
        if (!newVal) {
          // 关闭详情弹窗时取消高亮
          this.airSpaces.map(e => {
            if (e.myCustomId == this.airSpaceChooseId) {
              e.setStyle({
                color: this.allEyesModel ? 'rgba(210,204,235,0.48)' : e.myCustomType === 0 || e.myCustomType === 1
                  ? '#e21838'
                  : e.myCustomType === 3
                    ? '#21f48e'
                    : e.myCustomType === 4 || e.myCustomType === 21
                      ? 'yellow'
                      : e.myCustomType === 11
                        ? 'orange'
                        : null, //填充颜色, //边框颜色#aa0000
                fillColor: this.allEyesModel ? 'rgba(210,204,235,0.48)' : e.myCustomType === 0 || e.myCustomType === 1
                  ? 'rgba(226,24,56,0.48)'
                  : e.myCustomType === 3
                    ? 'rgba(32,180,67,0.48)'
                    : e.myCustomType === 4 || e.myCustomType === 21
                      ? 'rgba(252,255,44,0.48)'
                      : e.myCustomType === 11
                        ? 'rgba(248,168,34,0.48)'
                        : null, //填充颜色
                fillOpacity: 1, //填充透明度
                weight: 1 //边框宽度
              });
            }
          })
        }
      }
    }
  },
  mounted() {
    this.getAllProvince();
    this.startNotice();
    window.timer1 = setInterval(() => {
      this.getFacilitiesData();
      this.getAircraft();
      // this.startNotice()
    }, 60000);

    this.initMap();
    this.addHot();
    // this.airSpace();
    this.getPageData();
    // 航线
    this.planeAllWay();
    // 航点
    // this.airPort();
    //设备
    this.changeCommunicationEquipment();
    // this.changeCountermeasureEquipment()
    this.changeMonitorEquipment();
    this.changeNavigationEquipment();
    window.addEventListener("resize", this.handleResize, { passive: true });
  },
  created() {
    // 创建防抖函数
    // this.getRouteData(),
    this.debouncedChangeLine = _.debounce(this.changeLineShow, 500);
    this.debouncedChangeAirPot = _.debounce(this.changeAirPotShow, 500);
    this.debouncedChangeormalAirPot = _.debounce(
      this.changeNormalAirPotShow,
      500
    );
  },
  beforeDestroy() {
    if (window.timer1) {
      clearInterval(window.statisicsTimer);
      window.timer1 = null;
    }
  },
  methods: {
    //模拟折线图数据
    formatWithMonthLabels(values) {
      const result = [];
      const now = new Date();
      const currentMonth = now.getMonth();
      const currentYear = now.getFullYear();
      for (let i = 5; i >= 0; i--) {
        let month = currentMonth - i;
        let year = currentYear;
        // 处理跨年情况
        if (month < 0) {
          month += 12;
          year--;
        }
        // 格式化为 "YYYY-MM"
        const monthStr = `${year}-${(month + 1).toString().padStart(2, '0')}`;
        // 获取对应索引的值，超出长度则补0
        const value = values[5 - i] || 0;

        result.push([monthStr, value]);
      }

      return result;
    },
    updateChartStyle() {
      if (!this.myChart3) return;
      const newColorStops = this.allEyesModel
        ? [
          { offset: 0, color: 'rgba(255,255,255,0.80)' },
          { offset: 1, color: 'rgba(255,255,255,0.00)' }
        ]
        : [
          { offset: 0, color: '#00FFFF' },
          { offset: 1, color: 'rgba(0, 255, 255, 0)' }
        ];
      // 更新线条颜色
      const newLineColor = this.allEyesModel ? '#fff' : '#00ffff';
      // 应用新配置
      this.myChart3.setOption({
        series: [{
          lineStyle: { color: newLineColor },
          areaStyle: {
            normal: {
              color: {
                colorStops: newColorStops
              }
            }
          }
        }]
      });
    },
    initWS(ws) {
      ws.addEventListener("message", e => {
        let data = JSON.parse(e.data);
        if (data.type == 11) {
          this.airSpace();
        } else if (data.type == 12) {
          this.deletePlaneAllWay();
          this.planeAllWay();
        }
      });
    },
    getLastStatus() {
      if (this.isBigScreen) {
        this.initWS(this.wsBigScreen);
      } else {
        this.initWS(this.ws);
      }
    },
    //切换航线名显示隐藏
    changeAirLineName() {
      this.showAirLineName = !this.showAirLineName
      this.planLines.map(v => {
        if (this.showAirLineName && this.currentZoom > 10) {
          v.openTooltip();
        } else {
          v.closeTooltip();
        }
      })
    },
    addMapElement(key){
      switch(key){
        case "roadNetwork":
          this.roadNetworkObj = L.geoJSON(luwangGeoJson, {
            style: {
              color: this.isStyleApplied ? 'rgba(192, 240, 237,1)' : 'rgba(192, 240, 237,1)', // 城市边界颜色
              weight: 2,
              fillColor: this.isStyleApplied ? 'rgb(192, 240, 237,0.6)' : 'rgb(192, 240, 237,0.6)', // 填充颜色
              fillOpacity: 0.48, // 填充透明度
            }
          }).addTo(this.map);
          break;
        case "greenPart":
          this.greenPartObj = L.geoJSON(greenPartGeoJsont, {
            style: {
              color: this.isStyleApplied ? 'rgba(124,252,0,1)' : 'rgba(124,252,0,1)', // 城市边界颜色
              weight: 2,
              fillColor: this.isStyleApplied ? 'rgb(124,252,0,0.4)' : 'rgb(124,252,0,0.4)', // 填充颜色
              fillOpacity: 0.48, // 填充透明度
            }
          }).addTo(this.map);
          break;
        case  "river":
          this.riverObj = L.geoJSON(riverGeoJson, {
            style: {
              color: this.isStyleApplied ? 'rgba(30,144,255,1)' : 'rgba(30,144,255,1)', // 城市边界颜色
              weight: 2,
              fillColor: this.isStyleApplied ? 'rgb(30,144,255,0.6)' : 'rgb(30,144,255,0.6)', // 填充颜色
              fillOpacity: 0.48, // 填充透明度
            }
          }).addTo(this.map);
          break;

      }
    },
    //显示路网地图元素
    handelShowRoadNetwork(){
      this.showRoadNetwork = !this.showRoadNetwork
      if(this.showRoadNetwork){
        this.addMapElement("roadNetwork")
      }else if(this.roadNetworkObj){
        this.map.removeLayer(this.roadNetworkObj)
      }
    },
    //显示绿地地图元素
    handelShowGreenPart(){
      this.showGreenPart = !this.showGreenPart
      if(this.showGreenPart){
        this.addMapElement("greenPart")
      }else if(this.greenPartObj){
        this.map.removeLayer(this.greenPartObj);
      }
    },
    //显示水系图元素
    handelShowRiver(){
      this.showRiver = !this.showRiver
      if(this.showRiver){
        this.addMapElement("river")
      }else if(this.riverObj){
        this.map.removeLayer(this.riverObj);
      }
    },
    updateTheme() {
      const tileImages = document.querySelectorAll(".leaflet-tile-pane img");
      if (!this.isEyeshield) {
        tileImages.forEach(img => {
          img.classList.remove("sepia-grayscale");
        });
      } else {
        tileImages.forEach(img => {
          img.classList.add("sepia-grayscale");
        });
      }
    },
    //更新航线toolTip name 是否展示
    updateAirLineNameStatus() {
      if (this.planLines.length) {
        const shouldBe = this.currentZoom > 10;
        this.planLines.forEach(line => {
          if (shouldBe) {
            line.openTooltip();
          } else {
            line.closeTooltip();
          }
        });
      }
    },
    showMask() {
      // 加载城市的 GeoJSON 数据
      this.getRequest("/uav-task-server/airspace/getShanghaiGeoJson").then(
        res => {
          const oData = res.data;
          if (oData.code === 0) {
            const cityGeoJSON = JSON.parse(oData.data);
            // 创建一个城市图层
            // 创建城市的图层并添加到地图
            this.cityLayer = L.geoJSON(cityGeoJSON, {
              style: {
                color: this.allEyesModel
                  ? "rgba(214,211,241,1)"
                  : "rgba(255,254,190,1)", // 城市边界颜色
                weight: 2,
                fillColor: this.allEyesModel
                  ? "rgb(219,217,255,0.48)"
                  : "rgb(255,246,141,0.48)", // 填充颜色
                fillOpacity: 0.48, // 填充透明度
              }
            }).addTo(this.map);
            //初始化空域保证空域在遮罩之后渲染
            this.airSpace();
            // // 调整地图视图以适应城市边界
            // const cityBounds = L.geoJSON(cityGeoJSON).getBounds();
            // this.map.fitBounds(cityBounds); // 自适应地图视图
          }
        }
      );
    },
    drawBoundary() {
      // let svgGradientRed = `
      //                  <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
      //             <defs>
      //                 <radialGradient id="redBoundary" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
      //                      <stop offset="80%" style="stop-color:red; stop-opacity:0" />
      //                       <stop offset="100%" style="stop-color:red; stop-opacity:1" />
      //                 </radialGradient>
      //             </defs>
      //                  </svg>`;
      // document.getElementById('svg-container').insertAdjacentHTML('afterbegin', svgGradientRed);
      this.getRequest("/uav-task-server/airspace/getShanghaiGeoJson").then(
        res => {
          const oData = res.data;
          if (oData.code === 0) {
            L.geoJSON(JSON.parse(oData.data), {
              style: function (feature) {
                return {
                  color: "#00aeff", // 边界线颜色
                  weight: 4, // 边界线宽度
                  opacity: 0.7, // 边界线透明度
                  fill: false // 不填充内部
                  // dashArray: '10, 10' // 设置虚线样式，线段长度 10，间隔长度 10
                };
              }
            }).addTo(this.map);
          }
        }
      );
    },
    changeAirPotShow() {
      if (this.airLinePorts.length > 0) {
        this.airLinePorts.forEach(point => {
          this.map.removeLayer(point);
        });
        this.airLinePorts = [];
      }
      if (this.airLinePositions.length > 0) {
        this.airLinePositions.forEach(marker => {
          this.map.removeLayer(marker);
          this.airLinePositions = [];
        });
      }
      this.showairPort = !this.showairPort;
      let queryCode;
      if (this.selectedDistrict == 0) {
        if (this.selectCity == 0) {
          queryCode = this.selectProvince;
        } else {
          queryCode = this.selectCity;
        }
      } else {
        queryCode = this.selectedDistrict;
      }
      this.planeAllWay(queryCode);
    },
    changeNormalAirPotShow() {
      if (this.airLinePorts.length > 0) {
        this.airLinePorts.forEach(point => {
          this.map.removeLayer(point);
        });
        this.airLinePorts = [];
      }
      if (this.airLinePositions.length > 0) {
        this.airLinePositions.forEach(marker => {
          this.map.removeLayer(marker);
          this.airLinePositions = [];
        });
      }
      this.showNormalairPort = !this.showNormalairPort;
      let queryCode;
      if (this.selectedDistrict == 0) {
        if (this.selectCity == 0) {
          queryCode = this.selectProvince;
        } else {
          queryCode = this.selectCity;
        }
      } else {
        queryCode = this.selectedDistrict;
      }
      this.planeAllWay(queryCode);
    },
    addHot() {
      if (this.relituChecked) {
        var jsonShanghaiData = jsonData;

        // 处理 JSON 数据，转换为 leaflet.heat 插件所需的格式
        var heatData = jsonShanghaiData.map(function (item) {
          const point = wgs84ToGcj02(item.lng, item.lat);

          return [point[1], point[0], item.count];
        });

        // 调用渲染方法，传入半径，透明度参数，添加到地图
        this.heatLayer = L.heatLayer(heatData, {
          radius: 25
          // blur: 15,
        }).addTo(this.map);
      } else {
        if (this.heatLayer) {
          this.map.removeLayer(this.heatLayer);
        }
      }
    },
    changeLineShow() {
      this.showDubuleLine = !this.showDubuleLine;
      this.planeAllWay();
    },
    handleProvChange(code) {
      // 清空市和区绑定的值
      this.selectDistrict = "";
      this.selectCity = "";
      if (code == 0) {
        this.regionCode = null
        this.airSpace()
        return
      }
      this.getCityByProvince(code);
    },
    handleCiChange(code) {
      // 清空区绑定的值
      this.selectDistrict = "";
      this.getDistrictByCity(code);
    },
    handleDisChange(code) {
      this.selectedDistrict = code;
      // 清空区绑定的值
      let queryCode;
      if (code == 0) {
        if (this.selectCity == 0) {
          queryCode = this.selectProvince;
        } else {
          queryCode = this.selectCity;
        }
      } else {
        queryCode = code;
      }
      this.regionCode = queryCode
      this.airSpace();
      this.deletePlaneAllWay();
      this.planeAllWay(queryCode);
    },
    // queryChange(code){
    //   this.getRequest(`/uav-task-server/airspace/queryAirspace?all=all&regionCode=${code}`).then(res => {
    //                   let oData = res.data;
    //                   if (oData.code == 0) {
    //                     this.airSpace()

    //                   }
    //                 })
    // },
    getAllProvince() {
      this.getRequest("/uav-task-server/region/getAllProvince").then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          this.provinces = oData.data;
          this.province = oData.data;
          this.province.unshift({ code: "0", name: "全部" });
        }
      });
    },
    getCityByProvince(provinceCode) {
      if (provinceCode == 0) {
        return
      }
      this.getRequest(
        `/uav-task-server/region/getCity?provinceCode=${provinceCode}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          this.city = oData.data;
          this.city.unshift({ code: "0", name: "全部" });
        }
      });
    },
    getDistrictByCity(cityCode) {
      this.getRequest(
        `/uav-task-server/region/getDistrict?cityCode=${cityCode}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          this.district = oData.data;
          this.district.unshift({ code: "0", name: "全部" });
        }
      });
    },
    handleProvinceChange(provinceCode) {
      // 清空市和区绑定的值
      this.ruleForm.selectedDistrict = "";
      this.airSpaceInfo.selectedDistrict = "";
      this.ruleFormLine.selectedDistrict = "";
      this.ruleForm.selectedCity = "";
      this.airSpaceInfo.selectedCity = "";
      this.ruleFormLine.selectedCity = "";
      this.getCitiesByProvince(provinceCode);
    },
    handleDistrictChange(selectedProvince) {
      this.getRequest(
        `/uav-task-server/airspace/queryAirspace?all=all&bottomHeight=0&topHeight=810&regionCode=${selectedProvince}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          console.log(oData.data, "fhjghjghghj");
        }
      });
    },
    handleCityChange(cityCode) {
      // 清空区绑定的值
      this.ruleForm.selectedDistrict = "";
      this.airSpaceInfo.selectedDistrict = "";
      this.ruleFormLine.selectedDistrict = "";
      this.getDistrictsByCity(cityCode);
    },
    getCitiesByProvince(provinceCode) {
      return this.getRequest(
        `/uav-task-server/region/getCity?provinceCode=${provinceCode}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          this.cities = oData.data;
        }
      });
    },
    getDistrictsByCity(cityCode) {
      return this.getRequest(
        `/uav-task-server/region/getDistrict?cityCode=${cityCode}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          this.districts = oData.data;
        }
      });
    },

    handelDrawLine() {
      this.chooseLine = true;
      this.ruleFormLine.airpointlist = [];
      this.enablePolylineDrawing();
    },
    enablePolylineDrawing() {
      var polygonButton = document.getElementsByClassName(
        "leaflet-draw-draw-polyline"
      )[0];
      if (polygonButton) {
        polygonButton.click();
        // let tooltip = document.getElementsByClassName("leaflet-draw-tooltip")[0]
        //   .children[0];
        // tooltip.innerHTML = "双击结束绘制航线";
      }
    },
    cancelDraw() {
      this.chooseLine = false;
      // if (this.positionLine) {
      //   this.map.removeLayer(this.positionLine);
      // }
      if (this.drawnItems) {
        this.drawnItems.clearLayers();
        this.map.addControl(this.drawControl);
      }
      this.latlngsline = [];
    },
    changeAirPoint(value) {
      console.log("航点", value);
      console.log(this.landPoints);
      let selectedPoints = [];
      value.forEach(item => {
        let point = this.landPoints.find(pointData => pointData.id == item);
        selectedPoints.push(point);
      });
      this.airpointList = selectedPoints;
    },
    deleteEdit() {
      let tips = "<i class='el-icon-warn-tip'></i>是否确认删除?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style"
      }).then(() => {
        this.getRequest(
          "/uav-task-server/airspace/deleteAirspaceByObjectId?objectId=" +
          this.airSpaceInfo.objectId
        ).then(res => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470
            });
            // 成功后刷新
            this.showNofly();
            this.showCanfly();
            this.showLimit();
            this.flyArea = false;
          } else {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () { }
            });
          }
        });
      });
    },
    startNotice() {
      // 清除之前的定时器，确保不会重复创建
      if (this.startNoticeTimer) {
        clearInterval(this.startNoticeTimer);
        this.startNoticeTimer = null;
      }

      this.getRequest("/uav-task-server/planstatistic/getNoticeMessage").then(
        res => {
          let oData = res.data;
          if (oData.code == 0) {
            this.noticeData = oData.data;
            this.$forceUpdate();

            this.$nextTick(() => {
              const announcementList = document.querySelector(
                ".announcement-list"
              );
              if (!announcementList) return;

              // 重置滚动状态
              announcementList.style.transition = "none";
              announcementList.style.transform = "translateY(0)";

              const items = document.querySelectorAll(".announcement-item");
              if (!items.length) return;

              const itemHeight = 80; // 每个公告的高度

              // 移除之前可能存在的克隆节点
              const clonedItems = document.querySelectorAll(
                ".announcement-item-clone"
              );
              clonedItems.forEach(item => item.remove());

              // 克隆第一个公告项以实现无缝滚动
              const firstItemClone = items[0].cloneNode(true);
              firstItemClone.classList.add("announcement-item-clone"); // 添加标记类
              announcementList.appendChild(firstItemClone);

              let currentIndex = 0;

              const showNextAnnouncement = () => {
                currentIndex++;
                const offset = -currentIndex * itemHeight;
                announcementList.style.transition = "transform 0.5s ease";
                announcementList.style.transform = `translateY(${offset}px)`;

                // 当滚动到最后一个公告时，重置位置
                if (currentIndex >= this.noticeData.length) {
                  setTimeout(() => {
                    announcementList.style.transition = "none";
                    announcementList.style.transform = "translateY(0)";
                    currentIndex = 0;

                    // 给浏览器一点时间来应用样式变化
                    setTimeout(() => {
                      announcementList.style.transition = "transform 0.5s ease";
                    }, 50);
                  }, 500);
                }
              };

              // 创建新的定时器
              this.startNoticeTimer = setInterval(showNextAnnouncement, 3000);
            });
          }
        }
      );
    },
    //获取空域统计
    getRouteData() {
      return this.getRequest(
        "/uav-task-server/planstatistic/getSpaceCount"
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data;
          this.routeOriginData = records;
          let total =
            records.limit +
            records.appropriate +
            records.grid +
            records.forbidden;
          this.routeData = [
            {
              name: "电子围栏",
              rate: (records.grid * 100) / total,
              value: records.grid
            },
            {
              name: "受限区",
              rate: (records.limit * 100) / total,
              value: records.limit
            },
            {
              name: "适飞区",
              rate: (records.appropriate * 100) / total,
              value: records.appropriate
            },
            {
              name: "禁飞区",
              rate: (records.forbidden * 100) / total,
              value: records.forbidden
            }
          ];
          //   {name: "电子围栏", rate: records.grid * 100 / total, value: records.grid},].sort(function (a, b) {
          //   return b.value - a.value;
          // },)
        }
      });
    },
    //获取空域占用率
    getAirSpaceOccupancyRate() {
      return this.getRequest("/uav-task-server/planstatistic/getSpaceUse").then(
        res => {
          let oData = res.data;
          if (oData.code == 0) {
            let records
            if(oData.data.length < 5){
                records = [
              ...oData.data,
              { name: "上海空域-6", usenum: 42 },
              {
                name: "上海空域-4",
                usenum: 20
              },
              { name: "上海空域-3", usenum: 11 }
            ];
            }else{
              records = oData.data.slice(0, 5)
            }
            const sum = records.reduce(
              (accumulator, currentValue) => accumulator + currentValue.usenum,
              0
            );
            this.AirSpaceOccupancyRateData = {
              sdata: {
                value: records.map(v =>
                  parseFloat((v.usenum * 100) / sum).toFixed(1)
                )
              },
              ydata: { value: records.map(v => v.name) },
              numData: records.map(v => v.usenum)
            };
          }
        }
      );
    },
    //获取地面基础设施
    getFacilitiesData() {
      return this.getRequest(
        "/uav-task-server/planstatistic/getInfrastructure"
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data;
          this.facilitiesData = records;
        }
      });
    },
    //获取飞行概览数据
    getPlanView() {
      return this.getRequest("/uav-task-server/planstatistic/getPlanView").then(
        res => {
          let oData = res.data;
          if (oData.code == 0) {
            let records = oData.data;
            this.planViewData = {
              flySorties: records.flySorties,
              miles: records.miles,
              safeHours: records.safeHours,
              // safeHoursArr: records.monthHours.map(v => {
              //   return [v.month, v.hours]
              // }),
              // numsArr: records.monthHours.map(v => {
              //   return [v.month, v.nums]
              // }),
              // milesArr: records.monthHours.map(v => {
              //   return [v.month, v.miles]
              // }),
              safeHoursArr: this.formatWithMonthLabels([167, 83, 667, 1001, 531, 658]),
              numsArr: this.formatWithMonthLabels([343, 170, 1333, 2026, 1021, 1301]),
              milesArr: this.formatWithMonthLabels([1136, 1136, 5334, 8002, 3329, 4005]),
            };
          }
        }
      );
    },
    //获取飞行活动数据
    getPlanActivity() {
      return this.getRequest(
        "/uav-task-server/planstatistic/getPlanActivity"
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data;
          this.planActivity = {
            historyTimes: records.historyTimes,
            todayTimes: records.todayTimes,
            todayUnTimes: records.todayUnTimes,
            // TimesArr: records.monthTimes.map(v => {
            //   return [v.month, v.nums]
            // }),
            TimesArr: this.formatWithMonthLabels([343, 170, 1333, 2026, 1021, 1301]),
          };
        }
      });
    },
    //获取飞行器数据
    getAircraft() {
      return this.getRequest("/uav-task-server/planstatistic/getAircraft").then(
        res => {
          let oData = res.data;
          if (oData.code == 0) {
            let records = oData.data;
            this.aircraftData = {
              totalNum: records.totalNum,
              flyingNum: records.flyingNum,
              detail: records.detail.slice(0, 3).map(v => {
                return {
                  ...v,
                  rate: parseFloat(
                    ((v.num / records.totalNum) * 100).toFixed(2)
                  )
                };
              })
            };
          }
        }
      );
    },
    //获取页面两侧数据
    async getPageData() {
      await Promise.all([
        this.getRouteData(),
        this.getAirSpaceOccupancyRate(),
        this.getFacilitiesData(),
        this.getPlanView(),
        this.getPlanActivity(),
        this.getAircraft()
      ])
        .then(res => {
          this.initChart();
        })
        .catch(e => {
          this.initChart();
        });
    },
    initChart() {
      let _this = this;
      // this.initChangeChart()
      // 绘制图表
      this.myChart1 = echarts.init(document.getElementById("flyDataCharts"));
      this.myChart2 = echarts.init(document.getElementById("binCharts"));
      this.myChart3 = echarts.init(document.getElementById("flyActiveCharts"));

      let colorList = [];
      let sdata = { value: [] };
      let ydata = { value: [] };
      if (this.AirSpaceOccupancyRateData.sdata) {
        sdata =
          this.AirSpaceOccupancyRateData.sdata.value.length > 5
            ? { value: this.AirSpaceOccupancyRateData.sdata.value.slice(0, 5) }
            : this.AirSpaceOccupancyRateData.sdata; //百分数
        ydata =
          this.AirSpaceOccupancyRateData.ydata.value.length > 5
            ? { value: this.AirSpaceOccupancyRateData.ydata.value.slice(0, 5) }
            : this.AirSpaceOccupancyRateData.ydata; //百分数
        this.AirSpaceOccupancyRateData.sdata.value.map((v, index) => {
          if (index % 2 === 1) {
            colorList.push(
              new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: "#FF8C4D" },
                { offset: 1, color: "#FF8C4D" }
              ])
            );
          } else {
            colorList.push(
              new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: "#FF5555" },
                { offset: 1, color: "#FF5555" }
              ])
            );
          }
        });
      }
      const gradientColors = [
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            { offset: 0, color: "#00AEFF" },
            { offset: 1, color: "rgba(0,174,255,0.1)" }
          ]
        },
        {
          type: "linear",
          x: 0,
          y: 1,
          x2: 0,
          y2: 0,
          colorStops: [
            { offset: 0, color: "#FF7B2B" },
            { offset: 1, color: "rgba(255,123,43,0.1)" }
          ]
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            { offset: 0, color: "#00FFFF" },
            { offset: 1, color: "rgba(0,255,255,0.1)" }
          ]
        },
        {
          type: "linear",
          x: 0,
          y: 1,
          x2: 0,
          y2: 0,
          colorStops: [
            { offset: 0, color: "#EE3F3F" },
            { offset: 1, color: "rgba(238,63,63,0.1)" }
          ]
        }
      ];
      this.myChart1.setOption({
        tooltip: {
          trigger: "axis", // 鼠标悬停时触发
          formatter: function (params) {
            let result = `<strong>${params[0].name}</strong><br/>`; // 显示时间
            params.forEach(item => {
              result += `${_this.chartType === 1
                ? "运行小时数"
                : _this.chartType === 2
                  ? "运行架次"
                  : "运行里程"
                }: ${item.value[1]}${_this.chartType === 1
                  ? "小时"
                  : _this.chartType === 2
                    ? "次"
                    : "km"
                }<br/>`; // 显示数据
            });
            return result;
          },
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          padding: 10,
          textStyle: {
            color: "#333",
            fontSize: 14
          }
        },
        grid: {
          top: 33,
          left: 50,
          right: 30,
          bottom: 20,
          width: "auto",
          height: "auto"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)" // 坐标轴颜色
            }
          },
          axisLabel: {
            color: "#fff" // 坐标字体颜色
          },
          axisTick: {
            show: false // 去掉轴刻度线
          }
        },
        yAxis: {
          name:
            this.chartType === 1
              ? "(小时)"
              : this.chartType === 2
                ? "(次)"
                : "(km)",
          type: "value",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)" // 坐标轴颜色
            }
          },
          axisLabel: {
            color: "#fff" // 坐标字体颜色
          },
          axisTick: {
            show: false // 去掉轴刻度线
          },
          nameTextStyle: {
            color: "#fff"
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "solid",
              color: "rgba(255, 255, 255, 0.3)"
            },
            show: true
          }
        },
        series: [
          {
            type: "line",
            showSymbol: false, // 隐藏所有数据点
            // smooth: 1,
            lineStyle: {
              color: "#00AEFF",
              width: 3
            },
            areaStyle: {
              normal: {
                color: {
                  type: "linear", // 线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "#00AEFF" }, // 0% 处的颜色
                    { offset: 1, color: "rgba(0, 174, 255, 0)" } // 100% 处的颜色
                  ],
                  global: false // 使用区域渐变
                }
              }
            },
            data:
              this.chartType === 1
                ? this.planViewData.safeHoursArr
                : this.chartType === 2
                  ? this.planViewData.numsArr
                  : this.planViewData.milesArr,
            itemStyle: {
              // 设置数据点的大小和样式
              color: "#00AEFF", // 数据点颜色
              borderColor: "#00AEFF",
              borderWidth: 1 // 边框宽度
            },
            symbolSize: function (value) {
              return 6;
            }
          }
        ]
      });
      this.myChart2.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)"
        },
        label: {
          show: false,
          fontSize: "30",
          fontWeight: "bold"
        },
        color: gradientColors,
        series: [
          {
            // name:'g',
            type: "pie",
            radius: ["80%", "90%"],
            avoidLabelOverlap: false,
            labelLine: {
              show: false
            },
            label: {
              show: false // 隐藏柱状图上的数据标签
            },
            data: this.routeData
          }
        ]
      });
      this.myChart3.setOption({
        tooltip: {
          trigger: "axis", // 鼠标悬停时触发
          formatter: function (params) {
            let result = `<strong>${params[0].name}</strong><br/>`; // 显示时间
            params.forEach(item => {
              result += `飞行次数: ${item.value[1]}次<br/>`; // 显示数据
            });
            return result;
          },
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          padding: 10,
          textStyle: {
            color: "#333",
            fontSize: 14
          }
        },
        grid: {
          top: 33,
          left: 50,
          right: 30,
          bottom: 20,
          width: "auto",
          height: "auto"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)" // 坐标轴颜色
            }
          },
          axisLabel: {
            color: "#fff" // 坐标字体颜色
          },
          axisTick: {
            show: false // 去掉轴刻度线
          }
        },
        yAxis: {
          name: "(次)",
          type: "value",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)" // 坐标轴颜色
            }
          },
          axisLabel: {
            color: "#fff" // 坐标字体颜色
          },
          axisTick: {
            show: false // 去掉轴刻度线
          },
          nameTextStyle: {
            color: "#fff"
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "solid",
              color: "rgba(255, 255, 255, 0.3)"
            },
            show: true
          }
        },
        series: [
          {
            type: "line",
            showSymbol: false, // 隐藏所有数据点
            // smooth: 1,
            lineStyle: {
              color: this.allEyesModel ? '#fff' : '#00ffff',
              width: 3
            },
            areaStyle: {
              normal: {
                color: {
                  type: "linear", // 线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: this.allEyesModel ? 'rgba(255,255,255,0.80)' : '#00FFFF' }, // 0% 处的颜色
                    { offset: 1, color: this.allEyesModel ? 'rgba(255,255,255,0.00)' : 'rgba(0, 255, 255, 0)' }  // 100% 处的颜色
                  ],
                  global: false // 使用区域渐变
                }
              }
            },
            data: this.planActivity.TimesArr,
            itemStyle: {
              // 设置数据点的大小和样式
              color: "#00FFFF", // 数据点颜色
              borderColor: "#00FFFF",
              borderWidth: 1 // 边框宽度
            },
            symbolSize: function (value) {
              return 6;
            }
          }
        ]
      });
    },
    //左侧可切换折线图
    initChangeChart() {
      let _this = this;
      this.myChart1.setOption({
        tooltip: {
          trigger: "axis", // 鼠标悬停时触发
          formatter: function (params) {
            let result = `<strong>${params[0].name}</strong><br/>`; // 显示时间
            params.forEach(item => {
              result += `${_this.chartType === 1
                ? "运行小时数"
                : _this.chartType === 2
                  ? "运行架次"
                  : "运行里程"
                }: ${item.value[1]}${_this.chartType === 1
                  ? "小时"
                  : _this.chartType === 2
                    ? "次"
                    : "km"
                }<br/>`; // 显示数据
            });
            return result;
          },
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          padding: 10,
          textStyle: {
            color: "#333",
            fontSize: 14
          }
        },
        grid: {
          top: 33,
          left: 50,
          right: 30,
          bottom: 20,
          width: "auto",
          height: "auto"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)" // 坐标轴颜色
            }
          },
          axisLabel: {
            color: "#fff" // 坐标字体颜色
          },
          axisTick: {
            show: false // 去掉轴刻度线
          }
        },
        yAxis: {
          name:
            this.chartType === 1
              ? "(小时)"
              : this.chartType === 2
                ? "(次)"
                : "(km)",
          type: "value",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)" // 坐标轴颜色
            }
          },
          axisLabel: {
            color: "#fff" // 坐标字体颜色
          },
          axisTick: {
            show: false // 去掉轴刻度线
          },
          nameTextStyle: {
            color: "#fff"
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: "solid",
              color: "rgba(255, 255, 255, 0.3)"
            },
            show: true
          }
        },
        series: [
          {
            type: "line",
            // smooth: 1,
            showSymbol: false, // 隐藏所有数据点
            lineStyle: {
              color: "#00AEFF",
              width: 3
            },
            areaStyle: {
              normal: {
                color: {
                  type: "linear", // 线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "#00AEFF" }, // 0% 处的颜色
                    { offset: 1, color: "rgba(0, 174, 255, 0)" } // 100% 处的颜色
                  ],
                  global: false // 使用区域渐变
                }
              }
            },
            data:
              this.chartType === 1
                ? this.planViewData.safeHoursArr
                : this.chartType === 2
                  ? this.planViewData.numsArr
                  : this.planViewData.milesArr,
            itemStyle: {
              // 设置数据点的大小和样式
              color: "#00AEFF", // 数据点颜色
              borderColor: "#00AEFF",
              borderWidth: 1 // 边框宽度
            },
            symbolSize: function (value) {
              return 6;
            }
          }
        ]
      });
    },
    initMap() {
      var shanghaiBounds = L.latLngBounds([
        [30.4, 120.52], // 上海地理范围的西南角坐标
        [31.53, 122.12] // 上海地理范围的东北角坐标
      ]);
      // 初始化地图
      var layer = L.tileLayer(
        // "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}"
        this.satelliteUrlTemplate
      );
      //创建地图
      let map = L.map("airspace-container", {
        center: this.mapcenter, //中心坐标
        zoom: 10, //缩放级别
        minZoom: 3,
        maxZoom: 18,
        zoomControl: true, //缩放组件
        attributionControl: false, //去掉右下角logol
        layers: [layer] //图层
        // maxBounds: shanghaiBounds
      });
      this.currentZoom = map.getZoom();
      this.showMask(); //遮罩
      // this.drawBoundary()
      // // 加载并显示边界线数据
      // map.setView([24.9402, 118.1806], 10)
      this.map = map;

      // 初始化Leaflet.draw控件
      var drawnItems = new L.FeatureGroup();
      this.map.addLayer(drawnItems);
      // 初始化绘制控件
      this.drawControl = new L.Control.Draw({
        edit: {
          featureGroup: drawnItems
        },
        draw: {
          marker: {
            icon: L.icon({
              iconUrl: "../../static/blueMarker.png",
              iconSize: [30, 30]
              // 其他图标选项...
            })
          },
          polyline: {
            shapeOptions: {
              color: "#278BFB", // 设置绘制线条的颜色
              opacity: 0.8
            }
          }
        }
      });
      // 将绘制控件添加到地图上
      this.map.addControl(this.drawControl);
      // this.getUserLocation();
      // 监听绘制事件
      let that = this;
      map.on("draw:created", function (event) {
        // 将绘制的图层添加到地图上
        var layer = event.layer;
        var layerType = event.layerType;
        drawnItems.addLayer(layer);
        that.drawnItems = drawnItems;
        //获取多边形数据
        if (that.ploygonChecked) {
          //获取面积，结果单位是平方米
          let area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
          // 将面积转换为平方千米
          let areaInKm = area / 1000000;
          that.ruleForm.area = areaInKm.toFixed(2);
          // 获取图层的所有顶点
          var latlngs = layer.getLatLngs();
          let pointArr = [];
          latlngs[0].forEach(point => {
            let point1 = gcj02ToWgs84(point.lng, point.lat);
            pointArr.push(point1);
          });
          that.latlngs = pointArr.map(subArray =>
            subArray.map(num => Number(num.toFixed(7)))
          );
        }
        if (layerType == "polyline") {
          // let tooltip = document.getElementsByClassName(
          //   "leaflet-draw-tooltip"
          // )[0].children;
          // console.log("tooltip", tooltip);
          // if (tooltip.length > 1) {
          //   tooltip[2].innerHTML = "双击结束绘制";
          // } else {
          //   tooltip[0].innerHTML = "点击开始绘制航线";
          // }
          // tooltip.innerHTML = "双击结束绘制航线";
          // 获取航点的经纬度，清除表单数据
          var latlngs = layer.getLatLngs(); // 获取线上的所有顶点
          console.log(latlngs, "hjkhkj");
          let points = [];
          latlngs.forEach(item => {
            let point = gcj02ToWgs84(item.lng, item.lat);
            points.push([point[0], point[1]]);
          });
          that.latlngsline = points;
          console.log(that.latlngsline, "8");
        }
      });
      map.on("draw:drawstart", function (e) {
        if (e.layerType === "polyline") {
          // // 获取 tooltip 元素并修改其内容
          // let tooltip = document.getElementsByClassName(
          //   "leaflet-draw-tooltip"
          // )[0].children;
          // console.log("tooltip1", tooltip);
          // if (tooltip.length > 1) {
          //   tooltip[2].innerHTML = "双击结束绘制";
          // } else {
          //   tooltip[0].innerHTML = "点击开始绘制航线";
          // }
        }
      });
      //监听鼠标开始绘制事件
      map.on("mousedown", function (e) {
        if (that.circleChecked && that.addAirSpaseType === 1) {
          // 获取鼠标点击的经纬度作为圆心
          that.center = e.latlng;
        }
      });
      //监听鼠标结束绘制事件
      map.on("mouseup", function (e) {
        if (that.circleChecked && that.addAirSpaseType === 1) {
          // 计算圆形半径
          var radius = that.center.distanceTo(e.latlng);
          that.radius = radius;
          // 计算面积
          if (radius > 0) {
            let area = Math.PI * Math.pow(radius, 2);
            let areaInKm = area / 1000000;
            that.ruleForm.area = areaInKm.toFixed(2);
          }
        }
      });
      map.on("click", function (e) {
        console.log(e, "点击");
      });

      // 地图加载完成后再执行操作
        map.whenReady(() => {
        if (this.isBigScreen||this.ws) {
            this.getLastStatus();
          }
        if (that.isBigScreen) {
          that.updateTheme();
        } else {
          that.$emit("update-theme");
        }
        map.on("moveend", function () {
          if (that.isBigScreen) {
            that.updateTheme();
          } else {
            that.$emit("update-theme");
          }
        });
        //监听地图缩放
        map.on("zoomend", function () {
          // 获取当前缩放级别
          that.currentZoom = map.getZoom();
          if (that.isBigScreen) {
            that.updateTheme();
          } else {
            that.$emit("update-theme");
          }
          if (that.showAirLineName) {
            that.updateAirLineNameStatus()
          }
        });
      });
    },
    //告警时间限制
    validateNumber(rule, value, callback) {
      if (value === "" || value === undefined || value === null) {
        callback(new Error("请填写告警时间"));
      } else if (
        Number.isNaN(Number(value)) ||
        !Number.isInteger(Number(value)) ||
        value <= 0
      ) {
        callback(new Error("请填写大于0的整数"));
      } else {
        callback();
      }
    },
    validateDoubleNumber(rule, value, callback) {
      if (value === "" || value === undefined || value === null) {
        // 如果值为空，可根据需求决定是否通过验证，这里假设直接通过
        callback();
      } else {
        const num = Number(value);
        if (isNaN(num) || num <= 0) {
          callback(new Error("请输入一个正的整数或小数"));
        } else {
          callback();
        }
      }
    },
    //验证经纬度
    validateCoordinates(rule, value, callback) {
      // 正则表达式验证经纬度格式
      const coordinatePattern = /^-?((1[0-7]\d|\d{1,2})(\.\d{0,8})?|180(\.0{0,8})?),-?(([1-8]?\d)(\.\d{0,8})?|90(\.0{0,8})?)$/;
      if (!value) {
        callback(new Error("坐标点不能为空"));
      } else if (!coordinatePattern.test(value)) {
        callback(
          new Error("经度,纬度小数点后最多8位,例: -123.45678912,45.67891234")
        );
      } else {
        callback();
      }
    },
    //验证备注
    validateNote(rule, value, callback) {
      if (value == "机场") {
        callback(new Error("机场为敏感词"));
      } else {
        callback();
      }
    },
    //定位用户地理位置
    getUserLocation() {
      let _this = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            var lat = position.coords.latitude;
            var lon = position.coords.longitude;
            // 缩放级别 1: 整个世界
            // 缩放级别 5: 大洲
            // 缩放级别 10: 国家
            // 缩放级别 12: 大城市或州
            // 缩放级别 15: 城市或县
            // 缩放级别 17: 街道
            // 缩放级别 19: 建筑物
            let point = wgs84ToGcj02(lon, lat);
            _this.map.setView([point[1], point[0]], 10);
          },
          function (error) {
            // 错误回调
            console.log("Chrome只允许HTTPS站点请求地理位置信息");
            console.error("Error finding location:", error);
          }
        );
      } else {
        // 浏览器不支持Geolocation
        alert("Your browser doesn't support geolocation.");
      }
    },
    //显示禁飞区
    showNofly() {
      //绘制前清除空域
      if (this.noflyAirSpaces.length > 0) {
        this.noflyAirSpaces.forEach(item => {
          this.map.removeLayer(item);
        });
      }
      if (this.noflyChecked) {
      } else {
        //绘制前清除空域
        if (this.noflyAirSpaces.length > 0) {
          this.noflyAirSpaces.forEach(item => {
            this.map.removeLayer(item);
          });
          this.noflyAirSpaces = [];
        }
      }
    },
    //显示适飞区
    showCanfly() {
      //绘制前清除空域
      if (this.canflyAirSpaces.length > 0) {
        this.canflyAirSpaces.forEach(item => {
          this.map.removeLayer(item);
        });
      }
      if (this.canflyChecked) {
        this.airSpace(3);
      } else {
        //绘制前清除空域
        if (this.canflyAirSpaces.length > 0) {
          this.canflyAirSpaces.forEach(item => {
            this.map.removeLayer(item);
          });
          this.canflyAirSpaces = [];
        }
      }
    },
    //显示受限区
    showLimit() {
      //绘制前清除空域
      if (this.limitAirSpaces.length > 0) {
        this.limitAirSpaces.forEach(item => {
          this.map.removeLayer(item);
        });
      }
      if (this.limitChecked) {
        this.airSpace(4);
      } else {
        //绘制前清除空域
        if (this.limitAirSpaces.length > 0) {
          this.limitAirSpaces.forEach(item => {
            this.map.removeLayer(item);
          });
          this.limitAirSpaces = [];
        }
      }
    },
    //绘制设备图标
    equipmentTag(type, data) {
      if (data.length > 0) {
        data.map(v => {
          //转换经纬度为纬经度
          let wgsPoint = null;
          if (type === "weather") {
            wgsPoint = wgs84ToGcj02(
              v.weatherEquipment.longitude,
              v.weatherEquipment.latitude
            );
          } else if (type === "monitor") {
            let offsetLongitude = -0.001;
            let offsetLatitude = 0;
            wgsPoint = wgs84ToGcj02(
              v.longitude + offsetLongitude,
              v.latitude + offsetLatitude
            );
          } else if (type === "ADSB") {
            let offsetLongitude = +0.001;
            let offsetLatitude = 0;
            wgsPoint = wgs84ToGcj02(
              v.longitude + offsetLongitude,
              v.latitude + offsetLatitude
            );
          } else {
            wgsPoint = wgs84ToGcj02(v.longitude, v.latitude);
          }
          let myIcon = L.icon({
            iconUrl: `../../../static/${type === "ADSB"
              ? "ADSB"
              : type === "communication"
                ? "tongxin_tag"
                : type === "countermeasure"
                  ? "fanzhi_tag"
                  : type === "weather"
                    ? "qixiang_tag"
                    : type === "monitor"
                      ? v.online === 1
                        ? "camera"
                        : "camera_offline"
                      : type === "navigation"
                        ? "daohang_tag"
                        : type === "oneRadar"
                          ? "oneRadar_tag"
                          : ""
              }.png`,
            iconSize: [50, 60]
          });
          let markerPoint = L.marker([wgsPoint[1], wgsPoint[0]], {
            icon: myIcon
            // zIndexOffset: 1002, // 设置一个较高的z-index值
          }).addTo(this.map);
          if (type !== "weather") {
            markerPoint.bindTooltip(
              `<span style="color:#
            000;font-weight:bold;">${v.name}</span>`,
              {
                //内容可以自定义为HTML，如：<div>自定义结构</div>
                direction: "bottom", // 显示在底部
                sticky: false,
                offset: [0, 0] // 中心位置
              }
            );
          }
          // 图标根据地图放缩大小
          let _this = this;

          function getIconSize() {
            const zoomLevel = _this.map.getZoom();
            const size = (zoomLevel / 15) * 50; // 根据缩放级别调整大小
            return L.icon({
              iconUrl: `../../../static/${type === "ADSB"
                ? "ADSB"
                : type === "communication"
                  ? "tongxin_tag"
                  : type === "countermeasure"
                    ? "fanzhi_tag"
                    : type === "weather"
                      ? "qixiang_tag"
                      : type === "monitor"
                        ? v.online === 1
                          ? "camera"
                          : "camera_offline"
                        : type === "navigation"
                          ? "daohang_tag"
                          : type === "oneRadar"
                            ? "oneRadar_tag"
                            : ""
                }.png`,
              iconSize: [size, (size * 6) / 5]
            });
          }

          // 更新标记图标
          function updateMarker() {
            const newIcon = getIconSize();
            markerPoint.setIcon(newIcon);
          }

          updateMarker();
          // 监听地图缩放事件
          this.map.on("zoomend", updateMarker);
          if (type === "weather" && v.info) {
            markerPoint.bindTooltip(
              `<div class="weather" >
              <div class="top">
                <div class="address">
                  ${v.weatherEquipment.name}
                </div>
              </div>
              <div class="content">
                <div class="temperature">
                  ${v.info.temp}℃ &nbsp;

                </div>
                <div class="params">
                  <span>大气压强：${v.info.atm}kPa</span>
                </div>
                 <div class="params">
                  <span>降雨量：${v.info.precipitation}mm</span>&nbsp;&nbsp;
                  <span>噪音：${v.info.noise}dB</span>
                </div >
                <div class="bottom params"  style="display: flex;justify-content: space-between">
                  <span>风速：${v.info.windspeed}</span>
                  <span>风向：${v.info.windDirection}</span>
                  <span>湿度：${v.info.hum}</span>
                </div>
              </div>
            </div>`,
              {
                //内容可以自定义为HTML，如：<div>自定义结构</div>
                direction: "bottom", // 显示在底部
                sticky: false,
                className: "weather-toolTip",
                permanent: true,
                offset: [0, 35] // 中心位置
              }
            );
            markerPoint.on("click", e => {
              if (!markerPoint.isTooltipOpen()) {
                markerPoint.openTooltip();
              } else {
                markerPoint.closeTooltip();
              }
            });
          }
          switch (type) {
            case "communication":
              this.communicationEquipmentTag.push(markerPoint);
              break;
            case "monitor":
              this.monitorEquipmentTag.push(markerPoint);
              break;
            case "navigation":
              this.navigationEquipmentTag.push(markerPoint);
              break;
            case "weather":
              this.weatherEquipmentTag.push(markerPoint);
              break;
            case "countermeasure":
              this.countermeasureEquipmentTag.push(markerPoint);
              break;
            case "ADSB":
              this.ADSBEquipmentTag.push(markerPoint);
              break;
            case "oneRadar":
              this.oneRadarEquipmentTag.push(markerPoint);
              break;
          }
        });
      }
    },
    //绘制设备作用范围
    equipmentScope(type, data) {
      if (data.length > 0) {
        //通信设备
        let svgGradient = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:rgb(0,231,163); stop-opacity:0" />
                    <stop offset="100%" style="stop-color:rgb(0,231,163);stop-opacity:0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        //气象设备
        let svgGradient1 = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad1" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:rgb(0,255,252); stop-opacity:0" />
                    <stop offset="100%" style="stop-color:rgb(0,255,252);stop-opacity:0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        //侦测设备
        let svgGradient21 = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad21" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:green; stop-opacity:0" />
                    <stop offset="100%" style="stop-color:green;stop-opacity::0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        //
        let svgGradient22 = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad22" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:red; stop-opacity:0" />
                    <stop offset="100%" style="stop-color:red;stop-opacity::0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        //ADSB设备
        let svgGradient3 = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad3" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:rgb(255,177,27); stop-opacity:0" />
                    <stop offset="100%" style="stop-color:rgb(255,177,27);stop-opacity::0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        //导航设备
        let svgGradient4 = `
        <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
            <defs>
                <radialGradient id="grad4" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                     <stop offset="80%" style="stop-color:rgb(0,177,251); stop-opacity:0" />
                    <stop offset="100%" style="stop-color:rgb(0,177,251);stop-opacity::0.68" />
                </radialGradient>
            </defs>
        </svg>`;
        // 将 SVG 渐变添加到文档
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient);
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient1);
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient21);
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient22);
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient3);
        document
          .getElementById("svg-container")
          .insertAdjacentHTML("afterbegin", svgGradient4);
        if (type !== "countermeasure") {
          data.map(v => {
            //转换经纬度为纬经度
            let wgsPoint = null;
            if (type === "weather") {
              wgsPoint = wgs84ToGcj02(
                v.weatherEquipment.longitude,
                v.weatherEquipment.latitude
              );
            } else if (type === "monitor") {
              let offsetLongitude = -0.002;
              let offsetLatitude = 0;
              wgsPoint = wgs84ToGcj02(
                v.longitude + offsetLongitude,
                v.latitude + offsetLatitude
              );
            } else {
              wgsPoint = wgs84ToGcj02(v.longitude, v.latitude);
            }
            let polygon = L.circle([wgsPoint[1], wgsPoint[0]], {
              radius:
                type === "weather" ? v.weatherEquipment.distance : v.distance, // 设置圆的半径
              color:
                type === "ADSB" || type === "oneRadar"
                  ? "rgb(248,151,25)"
                  : type === "communication"
                    ? "rgb(0,231,163)"
                    : type === "weather"
                      ? "rgb(2,232,232)"
                      : type === "navigation"
                        ? "rgb(2,168,230)"
                        : "", // 设置圆的边框颜色
              fillColor:
                type === "ADSB" || type === "oneRadar"
                  ? "url(#grad3)"
                  : type === "communication"
                    ? "url(#grad)"
                    : type === "weather"
                      ? "url(#grad1)"
                      : type === "navigation"
                        ? "url(#grad4)"
                        : "", // 设置圆的填充颜色
              fillOpacity: 1, // 设置圆的填充透明度
              weight: 2 //边框宽度
            }).addTo(this.map);
            switch (type) {
              case "communication":
                this.communicationEquipmentData.push(polygon);
                break;
              case "monitor":
                this.monitorEquipmentData.push(polygon);
                break;
              case "navigation":
                this.navigationEquipmentData.push(polygon);
                break;
              case "weather":
                this.weatherEquipmentData.push(polygon);
                break;
              case "ADSB":
                this.ADSBEquipmentData.push(polygon);
                break;
              case "oneRadar":
                this.oneRadarEquipmentData.push(polygon);
                break;
            }
          });
        } else {
          data.map(v => {
            //转换经纬度为纬经度
            let wgsPoint = wgs84ToGcj02(v.longitude, v.latitude);
            let polygon = L.circle([wgsPoint[1], wgsPoint[0]], {
              radius: v.operatingDistance, // 设置圆的半径
              color: "green", // 设置圆的边框颜色
              fillColor: "url(#grad21)", // 设置圆的填充颜色
              fillOpacity: 1, // 设置圆的填充透明度
              weight: 2 //边框宽度
            }).addTo(this.map);
            polygon.bindTooltip(
              `<span style="color:#
                    000;font-weight:bold;">${v.name}</span>`,
              {
                //内容可以自定义为HTML，如：<div>自定义结构</div>
                direction: "bottom", // 显示在底部
                sticky: false,
                offset: [0, 0] // 中心位置
              }
            );
            let polygon1 = L.circle([wgsPoint[1], wgsPoint[0]], {
              radius: v.detectionDistance, // 设置圆的半径
              color: "red", // 设置圆的边框颜色
              fillColor: "url(#grad22)", // 设置圆的填充颜色
              fillOpacity: 1, // 设置圆的填充透明度
              weight: 2 //边框宽度
            }).addTo(this.map);
            polygon1.bindTooltip(
              `<span style="color:#
                    000;font-weight:bold;">${v.name}</span>`,
              {
                //内容可以自定义为HTML，如：<div>自定义结构</div>
                direction: "bottom", // 显示在底部
                sticky: false,
                offset: [0, 0] // 中心位置
              }
            );
            this.countermeasureEquipmentData.push(polygon);
            this.countermeasureEquipmentData.push(polygon1);
          });
        }
      }
    },
    //绘制空域
    airSpace() {
      const code = this.regionCode ? this.regionCode : "";
      this.getRequest(
        `/uav-task-server/airspace/queryAirspace?cateType=10&cateType=20&cateType=30&regionCode=${code}`
      ).then(res => {
        let _this = this;
        let oData = res.data;
        if (oData.code == 0) {
          //绘制前清除空域
          if (this.airSpaces.length > 0) {
            this.airSpaces.forEach(item => {
              this.map.removeLayer(item);
            });
          }
          let res = JSON.parse(oData.data);
          let features = res.features;
          if (!this.limitChecked) {
            features = features.filter(v => v.properties.TYPE !== 4);
          }
          if (!this.canflyChecked) {
            features = features.filter(v => v.properties.TYPE !== 3);
          }
          if (!this.noflyChecked) {
            features = features.filter(v => v.properties.TYPE !== 0);
          }
          if (!this.electronicFenceChecked) {
            features = features.filter(v => v.properties.TYPE !== 1);
          }
          //设置颜色分类
          if (features.length > 0) {
            //0 禁飞区（红色） 1 电子围栏（有个属性控制，在电子围栏内是否可飞，红色） 2. 3.适飞区(绿色) 4. 限飞区(黄色)  0-9 报告空域(大类)
            //11-19   11-管制空域(大类) //橙色
            //21-29   21-监视空域(大类) //黄色
            const colorType = ["red", "red", "", "green", "yellow"];
            //遍历每一类的空域
            features.forEach(space => {
              const info = space.properties;
              let shapeType = info.SHAPETYPE;
              //遍历该类型下的所有空域多边形
              space.geometry.coordinates.forEach(coordinate => {
                //转换经纬度为纬经度
                let changedCoord = [];
                coordinate[0].forEach(point => {
                  let wgsPoint = wgs84ToGcj02(point[0], point[1]);
                  changedCoord.push([wgsPoint[1], wgsPoint[0]]);
                });
                let svgGradient1 = `
                       <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                  <defs>
                      <radialGradient id="redSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           <stop offset="80%" style="stop-color:#ff5555; stop-opacity:0" />
                            <stop offset="100%" style="stop-color:#ff5555;stop-opacity:1" />
                      </radialGradient>
                  </defs>
                       </svg>`;
                let svgGradient2 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="greenSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                             <stop offset="80%" style="stop-color:#0fd077; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:#0fd077;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                let svgGradient3 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="yellowSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           <stop offset="80%" style="stop-color:#ffc877; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:#ffc877;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                let svgGradient4 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="graySpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           stop offset="80%" style="stop-color:gray; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:gray;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                let svgGradient5 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="orangeSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           stop offset="80%" style="stop-color:orange; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:orange;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                // 将 SVG 渐变添加到文档
                document
                  .getElementById("svg-container")
                  .insertAdjacentHTML("afterbegin", svgGradient1);
                document
                  .getElementById("svg-container")
                  .insertAdjacentHTML("afterbegin", svgGradient2);
                document
                  .getElementById("svg-container")
                  .insertAdjacentHTML("afterbegin", svgGradient3);
                document
                  .getElementById("svg-container")
                  .insertAdjacentHTML("afterbegin", svgGradient4);
                document
                  .getElementById("svg-container")
                  .insertAdjacentHTML("afterbegin", svgGradient5);
                let polygon = null;
                if (shapeType == 0) {
                  //0多边形，1圆形
                  //绘制多边形
                  polygon = L.polygon(changedCoord, {
                    color:
                      this.allEyesModel ? 'rgba(214,211,241,0.48)' : info.TYPE === 0 || info.TYPE === 1
                        ? "#e21838"
                        : info.TYPE === 3
                          ? "#21f48e"
                          : info.TYPE === 4 || info.TYPE === 21
                            ? "yellow"
                            : info.TYPE === 11
                              ? "orange"
                              : null, //填充颜色, //边框颜色#aa0000
                    fillColor:
                      this.allEyesModel ? 'rgba(214,211,241,0.48)' : info.TYPE === 0 || info.TYPE === 1
                        ? "rgba(226,24,56,0.48)"
                        : info.TYPE === 3
                          ? "rgba(32,180,67,0.48)"
                          : info.TYPE === 4 || info.TYPE === 21
                            ? "rgba(252,255,44,0.48)"
                            : info.TYPE === 11
                              ? "rgba(248,168,34,0.48)"
                              : null, //填充颜色
                    fillOpacity: 1, //填充透明度
                    weight: 1 //边框宽度
                  }).addTo(this.map);
                  polygon.myCustomId = space.properties.id
                  polygon.myCustomType = space.properties.TYPE
                  //双击修改空域
                  polygon.on("dblclick", e => {
                    this.open = false;
                    if (
                      (info.remark && info.remark.includes("机场")) ||
                      !this.uBtnPermissionList.includes(
                        "MunicipalLevelData-add"
                      )
                    ) {
                      return;
                    }
                    const loading = this.$loading({
                      lock: true,
                      text: '加载中',
                      customClass: 'loadingStyle',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                    });
                    polygon.setStyle({
                      color: '#5eccff',          // 边框颜色
                      fillColor: 'rgba(0,174,255,0.68)',      // 填充颜色
                      fillOpacity: 1,          // 填充透明度
                      weight: 1,                 // 边框宽度
                    });
                    this.airSpaceChooseId = space.properties.id
                    this.getRequest(
                      "/uav-task-server/airspace/getAirspaceById?id=" + info.id
                    ).then(res => {
                      let oData = res.data;
                      if (oData.code == 0) {
                        const infoData = oData.data;
                        this.airSpaceInfo = {
                          type: "",
                          height: "",
                          bottomHeight: "",
                          institution: "",
                          name: "",
                          date1: "",
                          date2: "",
                          minute: "",
                          area: "",
                          note: "",
                          airspacePointArry: "",
                          airSpaseCoordinateArr: [{ value: "" }],
                          center: "",
                          radius: "",
                          id: null,
                          objectId: null,
                          approvingUnit: "",
                          approvingType: "",
                          selectedCity: '',
                          selectedProvince: '',
                          selectedDistrict: ''
                        };
                        this.shapeType = 0;
                        this.airSpaceInfo.type = infoData.type;
                        this.airSpaceInfo.airSpaseCoordinateArr = infoData.coordinates
                          .split("-")
                          .map(v => ({
                            value: v
                          }));
                        this.airSpaceInfo.height = infoData.height;
                        this.airSpaceInfo.date2 = new Date(infoData.endTime);
                        this.airSpaceInfo.minute = infoData.alarmTime;
                        this.airSpaceInfo.date1 = new Date(infoData.startTime);
                        this.airSpaceInfo.name = infoData.airspaceName;
                        this.airSpaceInfo.institution = infoData.applicant;
                        this.airSpaceInfo.area = infoData.area;
                        this.airSpaceInfo.note = infoData.remark;
                        this.airSpaceInfo.id = info.id;
                        this.airSpaceInfo.objectId = infoData.objectId;
                        this.airSpaceInfo.bottomHeight = infoData.bottomHeight;
                        this.airSpaceInfo.approvingUnit =
                          infoData.approvingUnit;
                        this.airSpaceInfo.approvingType =
                          infoData.approvingType;
                        if (infoData.provinceName) {
                          this.airSpaceInfo.selectedProvince = infoData.provinceCode;
                          this.getCitiesByProvince(infoData.provinceCode).then(() => {
                            if (infoData.cityName) {
                              this.airSpaceInfo.selectedCity = infoData.cityCode;
                              this.getDistrictsByCity(infoData.cityCode).then(
                                () => {
                                  if (infoData.regionName) {
                                    this.airSpaceInfo.selectedDistrict = infoData.regionCode;
                                  } else {
                                    this.airSpaceInfo.selectedDistrict = ''
                                  }

                                  this.flyArea = true;
                                  loading.close()
                                }
                              );
                            } else {
                              this.airSpaceInfo.selectedCity = ''
                              this.flyArea = true;
                              loading.close()
                            }
                          });
                        } else {
                          this.airSpaceInfo.selectedProvince = ''
                          this.flyArea = true;
                          loading.close()
                        }
                      } else {
                        loading.close()
                        this.$message.error({
                          message: oData.msg,
                          duration: 1000,
                          customClass: "message-warn-s",
                          iconClass: "el-icon-warn-tip",
                          offset: 470,
                          onClose: function () { }
                        });
                      }
                    });
                  });
                } else {
                  polygon = L.circle(changedCoord[0], {
                    radius: info.RADIUS, // 设置圆的半径
                    color:
                      this.allEyesModel ? 'rgba(214,211,241,0.48)' : info.TYPE === 0 || info.TYPE === 1
                        ? "#e21838"
                        : info.TYPE === 3
                          ? "#21f48e"
                          : info.TYPE === 4 || info.TYPE === 21
                            ? "yellow"
                            : info.TYPE === 11
                              ? "orange"
                              : null, //填充颜色, //边框颜色#aa0000
                    fillColor:
                      this.allEyesModel ? 'rgba(214,211,241,0.48)' : info.TYPE === 0 || info.TYPE === 1
                        ? "rgba(226,24,56,0.48)"
                        : info.TYPE === 3
                          ? "rgba(32,180,67,0.48)"
                          : info.TYPE === 4 || info.TYPE === 21
                            ? "rgba(252,255,44,0.48)"
                            : info.TYPE === 11
                              ? "rgba(248,168,34,0.48)"
                              : null, //填充颜色
                    fillOpacity: 1, //填充透明度
                    weight: 1 //边框宽度
                  }).addTo(this.map);
                  polygon.myCustomId = space.properties.id
                  polygon.myCustomType = space.properties.TYPE
                  polygon.on("dblclick", e => {
                    this.open = false;
                    if (
                      !this.uBtnPermissionList.includes(
                        "MunicipalLevelData-add"
                      )
                    ) {
                      return;
                    }
                    this.airSpaceChooseId = space.properties.id
                    const loading = this.$loading({
                      lock: true,
                      text: '加载中',
                      customClass: 'loadingStyle',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                    });
                    polygon.setStyle({
                      color: '#5eccff',          // 边框颜色
                      fillColor: 'rgba(0,174,255,0.68)',      // 填充颜色
                      fillOpacity: 1,          // 填充透明度
                      weight: 1,                 // 边框宽度
                    });
                    this.getRequest(
                      "/uav-task-server/airspace/getAirspaceById?id=" + info.id
                    ).then(res => {
                      let oData = res.data;
                      const infoData = oData.data;
                      if (oData.code === 0) {
                        this.airSpaceInfo = {
                          type: "",
                          height: "",
                          bottomHeight: 0,
                          institution: "",
                          name: "",
                          date1: "",
                          date2: "",
                          minute: "",
                          area: "",
                          note: "",
                          airspacePointArry: "",
                          airSpaseCoordinateArr: [{ value: "" }],
                          center: "",
                          radius: "",
                          id: null,
                          objectId: null,
                          approvingUnit: "",
                          approvingType: "",
                          selectedCity: '',
                          selectedProvince: '',
                          selectedDistrict: ''
                        };
                        this.shapeType = 1;
                        this.airSpaceInfo.type = infoData.type;
                        this.airSpaceInfo.height = infoData.height;
                        this.airSpaceInfo.center = infoData.coordinates.split(',').map(v => (parseFloat(v).toFixed(8))).join(',')
                        this.airSpaceInfo.date2 = new Date(infoData.endTime);
                        this.airSpaceInfo.minute = infoData.alarmTime;
                        this.airSpaceInfo.date1 = new Date(infoData.startTime);
                        this.airSpaceInfo.name = infoData.airspaceName;
                        this.airSpaceInfo.institution = infoData.applicant;
                        this.airSpaceInfo.area = infoData.area;
                        this.airSpaceInfo.note = infoData.remark;
                        this.airSpaceInfo.radius = infoData.radius;
                        this.airSpaceInfo.id = infoData.id;
                        this.airSpaceInfo.objectId = infoData.objectId;
                        this.airSpaceInfo.bottomHeight = infoData.bottomHeight;
                        this.airSpaceInfo.approvingUnit = infoData.approvingUnit;
                        this.airSpaceInfo.approvingType = infoData.approvingType;
                        if (infoData.provinceName) {
                          this.airSpaceInfo.selectedProvince = infoData.provinceCode;
                          this.getCitiesByProvince(infoData.provinceCode).then(() => {
                            if (infoData.cityName) {
                              this.airSpaceInfo.selectedCity = infoData.cityCode;
                              this.getDistrictsByCity(infoData.cityCode).then(
                                () => {
                                  if (infoData.regionName) {
                                    this.airSpaceInfo.selectedDistrict = infoData.regionCode;
                                  } else {
                                    this.airSpaceInfo.selectedDistrict = ''
                                  }

                                  this.flyArea = true;
                                  loading.close()
                                }
                              );
                            } else {
                              this.airSpaceInfo.selectedCity = ''
                              this.flyArea = true;
                              loading.close()
                            }
                          });
                        } else {
                          this.airSpaceInfo.selectedProvince = ''
                          this.flyArea = true;
                          loading.close()
                        }
                      } else {
                        loading.close()
                        this.$message.error({
                          message: oData.msg,
                          duration: 1000,
                          customClass: "message-warn-s",
                          iconClass: "el-icon-warn-tip",
                          offset: 470,
                          onClose: function () { }
                        });
                      }
                    });
                  });
                }
                let _this = this;
                // 添加 hover 事件监听器 移入移出
                if (polygon) {
                  let popup;

                  function togglePopup(latlng, showPopup, map) {
                    if (showPopup) {
                      popup = L.popup({
                        closeButton: false // 设置closeButton为false来隐藏关闭按钮
                      })
                        .setLatLng(latlng)
                        .setContent(
                          `
                            <div style="color:#000;font-weight:bold;text-align: center;font-size: 14px">${info.airspaceName
                          }(${info.BOTTOM_HEIHGT}~${info.HEIGHT +
                          info.BOTTOM_HEIHGT}m)</div>
                           <div>${info.STARTTIME} ~ ${info.ENDTIME} </div>
                          `
                        )
                        .openOn(map);
                    } else {
                      popup.close();
                    }
                  }

                  polygon.on("mouseover", function (e) {
                    //这里this指向map
                    togglePopup(e.latlng, true, _this.map);
                  });
                  polygon.on("mouseout", function (e) {
                    togglePopup(e.latlng, false, _this.map, e);
                  });
                }
                polygon.type = info.TYPE
                this.airSpaces.push(polygon);
              });
            });
            // this.airSpaces = airSpaces;
          }
          //将航线 移动到最顶层
          if (this.planlineWhite.length > 0) {
            this.planlineWhite.forEach(planline => {
              planline.removeFrom(this.map);
              planline.addTo(this.map);
            });
          }
          if (this.planLines.length > 0) {
            this.planLines.forEach(planline => {
              planline.removeFrom(this.map);
              planline.addTo(this.map);
            });
          }
        } else {
          console.log(oData.msg);
        }
      });
    },
    deletePlaneAllWay() {
      if (this.planLines.length > 0) {
        this.planLines.forEach(planline => {
          this.map.removeLayer(planline);
        });
        this.planLines = [];
      }
      if (this.planlineWhite.length > 0) {
        this.planlineWhite.forEach(planline => {
          this.map.removeLayer(planline);
        });
        this.planlineWhite = [];
      }

      if (this.airLinePorts.length > 0) {
        this.airLinePorts.forEach(point => {
          this.map.removeLayer(point);
        });
        this.airLinePorts = [];
      }
      if (this.airLinePositions.length > 0) {
        this.airLinePositions.forEach(marker => {
          this.map.removeLayer(marker);
          this.airLinePositions = [];
        });
      }
    },
    clickRoad() {
      this.clickroad = !this.clickroad;
      if (this.clickroad) {
        this.clickstar = false;
        this.switchLayer("road");
      } else {
        this.switchLayer("back");
      }
    },
    clickStar() {
      this.clickstar = !this.clickstar;
      if (this.clickstar) {
        this.clickroad = false;
        this.switchLayer("satellite");
      } else {
        this.switchLayer("back");
      }
    },
    async changeCommunicationEquipment(flag) {
      if (flag === true) {
        if (this.isDisplayCommunicationEquipment) {
          await this.getRequest(
            "/uav-task-server/communicationEquipment/queryAll"
          ).then(res => {
            this.equipmentTag("communication", res.data.data);
          });
        }
        return;
      }
      this.isDisplayCommunicationEquipment = !this
        .isDisplayCommunicationEquipment;
      if (this.communicationEquipmentData.length > 0) {
        this.communicationEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.communicationEquipmentData = [];
        });
      }
      if (this.communicationEquipmentTag.length > 0) {
        this.communicationEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.communicationEquipmentTag = [];
        });
      }
      if (this.isDisplayCommunicationEquipment) {
        await this.getRequest(
          "/uav-task-server/communicationEquipment/queryAll"
        ).then(res => {
          this.equipmentTag("communication", res.data.data);
          // this.equipmentScope('communication', res.data.data)
        });
      }
    },
    async changeADSBEquipment(flag) {
      if (flag === true) {
        if (this.showADSB) {
          await this.getRequest(
            "/uav-task-server/surveillanceEquipment/queryAllByType?type=1"
          ).then(res => {
            this.equipmentTag("ADSB", res.data.data);
            this.equipmentScope("ADSB", res.data.data);
          });
        }
        return;
      }
      this.showADSB = !this.showADSB;
      if (this.ADSBEquipmentData.length > 0) {
        this.ADSBEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.ADSBEquipmentData = [];
        });
      }
      if (this.ADSBEquipmentTag.length > 0) {
        this.ADSBEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.ADSBEquipmentTag = [];
        });
      }
      if (this.showADSB) {
        await this.getRequest(
          "/uav-task-server/surveillanceEquipment/queryAllByType?type=1"
        ).then(res => {
          this.equipmentTag("ADSB", res.data.data);
          this.equipmentScope("ADSB", res.data.data);
        });
      }
    },
    async changeOneRadarEquipment(flag) {
      if (flag === true) {
        if (this.showOneRadar) {
          await this.getRequest(
            "/uav-task-server/surveillanceEquipment/queryAllByType?type=2"
          ).then(res => {
            this.equipmentTag("oneRadar", res.data.data);
            this.equipmentScope("oneRadar", res.data.data);
          });
        }
        return;
      }
      this.showOneRadar = !this.showOneRadar;
      if (this.oneRadarEquipmentData.length > 0) {
        this.oneRadarEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.oneRadarEquipmentData = [];
        });
      }
      if (this.oneRadarEquipmentTag.length > 0) {
        this.oneRadarEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.oneRadarEquipmentTag = [];
        });
      }
      if (this.showOneRadar) {
        await this.getRequest(
          "/uav-task-server/surveillanceEquipment/queryAllByType?type=2"
        ).then(res => {
          this.equipmentTag("oneRadar", res.data.data);
          this.equipmentScope("oneRadar", res.data.data);
        });
      }
    },
    async changeCountermeasureEquipment(flag) {
      if (flag === true) {
        if (this.isDisplayCountermeasureEquipment) {
          await this.getRequest(
            "/uav-task-server/countermeasureEquipment/queryAll"
          ).then(res => {
            this.equipmentTag("countermeasure", res.data.data);
            this.equipmentScope("countermeasure", res.data.data);
          });
        }
        return;
      }
      this.isDisplayCountermeasureEquipment = !this
        .isDisplayCountermeasureEquipment;
      if (this.countermeasureEquipmentData.length > 0) {
        this.countermeasureEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.countermeasureEquipmentData = [];
        });
      }
      if (this.countermeasureEquipmentTag.length > 0) {
        this.countermeasureEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.countermeasureEquipmentTag = [];
        });
      }
      if (this.isDisplayCountermeasureEquipment) {
        await this.getRequest(
          "/uav-task-server/countermeasureEquipment/queryAll"
        ).then(res => {
          this.equipmentTag("countermeasure", res.data.data);
          this.equipmentScope("countermeasure", res.data.data);
        });
      }
    },
    async changeWeatherEquipment(flag) {
      if (flag === true) {
        if (this.isDisplayWeatherEquipment) {
          await this.getRequest(
            "/uav-task-server/weatherEquipment/queryWeatherInfo"
          ).then(res => {
            this.equipmentTag("weather", res.data.data);
            this.equipmentScope("weather", res.data.data);
          });
        }
        return;
      }
      this.isDisplayWeatherEquipment = !this.isDisplayWeatherEquipment;
      if (this.weatherEquipmentData.length > 0) {
        this.weatherEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.weatherEquipmentData = [];
        });
      }
      if (this.weatherEquipmentTag.length > 0) {
        this.weatherEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.weatherEquipmentTag = [];
        });
      }
      if (this.isDisplayWeatherEquipment) {
        await this.getRequest(
          "/uav-task-server/weatherEquipment/queryWeatherInfo"
        ).then(res => {
          this.equipmentTag("weather", res.data.data);
          this.equipmentScope("weather", res.data.data);
        });
      }
    },
    async changeMonitorEquipment(flag) {
      if (flag === true) {
        if (this.isDisplayMonitorEquipment) {
          await this.getRequest(
            "/uav-task-server/videoEquipment/queryAll"
          ).then(res => {
            this.equipmentTag("monitor", res.data.data);
            this.equipmentScope("monitor", res.data.data);
          });
        }
        return;
      }
      this.isDisplayMonitorEquipment = !this.isDisplayMonitorEquipment;
      if (this.monitorEquipmentData.length > 0) {
        this.monitorEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.monitorEquipmentData = [];
        });
      }
      if (this.monitorEquipmentTag.length > 0) {
        this.monitorEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.monitorEquipmentTag = [];
        });
      }
      if (this.isDisplayMonitorEquipment) {
        await this.getRequest(
          "/uav-task-server/videoEquipment/queryAll"
        ).then(res => {
          this.equipmentTag("monitor", res.data.data);
          this.equipmentScope("monitor", res.data.data);
        });
      }
    },
    async changeNavigationEquipment(flag) {
      if (flag === true) {
        if (this.isDisplayNavigationEquipment) {
          await this.getRequest(
            "/uav-task-server/navigationEquipment/queryAll"
          ).then(res => {
            this.equipmentTag("navigation", res.data.data);
            this.equipmentScope("navigation", res.data.data);
          });
        }
        return;
      }
      this.isDisplayNavigationEquipment = !this.isDisplayNavigationEquipment;
      if (this.navigationEquipmentData.length > 0) {
        this.navigationEquipmentData.forEach(v => {
          this.map.removeLayer(v);
          this.navigationEquipmentData = [];
        });
      }
      if (this.navigationEquipmentTag.length > 0) {
        this.navigationEquipmentTag.forEach(v => {
          this.map.removeLayer(v);
          this.navigationEquipmentTag = [];
        });
      }
      if (this.isDisplayNavigationEquipment) {
        await this.getRequest(
          "/uav-task-server/navigationEquipment/queryAll"
        ).then(res => {
          this.equipmentTag("navigation", res.data.data);
          this.equipmentScope("navigation", res.data.data);
        });
      }
    },
    switchLayer(layerType) {
      window.postMessage("changeLayerType", "*");
      // this.againPlaneWay();
      switch (layerType) {
        case "road":
          this.activeLayer = 1;
          // 移除现有图层并添加路网图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.roadUrlTemplate, {
            ltype: "11",
            attribution: "高德地图路网"
          }).addTo(this.map);
          break;
        case "satellite":
          this.activeLayer = 2;
          // 移除现有图层并添加卫星影像图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.satelliteUrlTemplate, {
            attribution: "高德地图卫星影像"
          }).addTo(this.map);
          break;
        case "hot":
          this.activeLayer = 3;
          // 定义热力点数量，加热力半径
          var heatNumbers = 150,
            heatRadius = 30;
          // 加热力坐标信息数组
          var heatPoints = [];
          // 遍历添加坐标信息
          for (var i = 0; i < heatNumbers; i++) {
            heatPoints[i] = [
              Math.random() * 0.28 + 39.78,
              Math.random() * 0.5 + 116.12,
              Math.random() * 80
            ];
          }
          if (this.heatLayer) {
            this.map.removeLayer(this.heatLayer);
          }
          if (this.velocityLayer) {
            this.map.removeLayer(this.velocityLayer);
          }
          // 调用渲染方法，传入半径，透明度参数，添加到地图
          this.heatLayer = L.heatLayer(heatPoints, {
            radius: heatRadius,
            minOpacity: 0.5
          }).addTo(this.map);

          break;
        case "wind":
          this.activeLayer = 3;
          var heatNumbers = 150,
            heatRadius = 30;
          // 加热力坐标信息数组
          var windData = [];
          // 遍历添加坐标信息
          for (var i = 0; i < heatNumbers; i++) {
            windData[i] = {
              lat: Math.random() * 0.28 + 39.78,
              lng: Math.random() * 0.5 + 116.12,
              angle: 45
            };
          }

          // 调用渲染方法，传入半径，透明度参数，添加到地图
          if (this.heatLayer) {
            this.map.removeLayer(this.heatLayer);
          }
          if (this.velocityLayer) {
            this.map.removeLayer(this.velocityLayer);
          }
          // 循环风向数据，绘制风向箭头
          var layer = windLayer(data);
          layer.addTo(this.map);

          break;
        // ... 同理添加其他图层
        case "back":
          this.activeLayer = 4;
          // 移除现有图层并添加路网图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.originLayer, {
            attribution: "高德原影像"
          }).addTo(this.map);
          break;
      }
    },
    close() {
      if (this.autoAirSpase) {
        this.map.removeLayer(this.autoAirSpase);
        this.autoAirSpase = null;
      }
      this.$refs.ruleForm.resetFields();
      this.$refs.ruleFormLine.resetFields();
      this.$refs.airSpaceInfo.resetFields();
      this.cities = [];
      this.districts = [];
      this.addAirSpaseType = 1;
      this.open = false;
      this.flyArea = false;
      this.ploygonChecked = false;
      this.circleChecked = false;
      this.cancel();
      this.cancelLine();
    },
    removeCoordinate(item) {
      let index = this.ruleForm.airSpaseCoordinateArr.indexOf(item);
      if (index !== -1) {
        this.ruleForm.airSpaseCoordinateArr.splice(index, 1);
      }
    },
    addCoordinate() {
      this.ruleForm.airSpaseCoordinateArr.push({
        value: "",
        key: Date.now()
      });
    },
    removeCoordinateByedit(item) {
      let index = this.airSpaceInfo.airSpaseCoordinateArr.indexOf(item);
      if (index !== -1) {
        this.airSpaceInfo.airSpaseCoordinateArr.splice(index, 1);
      }
    },
    addCoordinateByedit() {
      this.airSpaceInfo.airSpaseCoordinateArr.push({
        value: "",
        key: Date.now()
      });
    },
    //计算多边形面积
    calculateArea(arg, editType) {
      let area = 0;
      if (editType) {
        if (editType === "ploygon") {
          const points = arg.map(v => {
            return {
              lat: wgs84ToGcj02(v[0], v[1])[1],
              lng: wgs84ToGcj02(v[0], v[1])[0]
            };
          });
          area = L.GeometryUtil.geodesicArea(points);
        } else {
          area = Math.PI * Math.pow(arg, 2);
        }
      } else {
        if (this.ploygonChecked) {
          const points = arg.map(v => {
            return {
              lat: wgs84ToGcj02(v[0], v[1])[1],
              lng: wgs84ToGcj02(v[0], v[1])[0]
            };
          });
          area = L.GeometryUtil.geodesicArea(points);
        } else if (this.circleChecked || this.airSpaceInfo.radius) {
          area = Math.PI * Math.pow(arg, 2);
        }
      }
      return (area / 1000000).toFixed(2); // 1° 经度 ≈ 111320 米，1° 纬度 ≈ 111320 米 1平方千米=1000000平方米
    },
    //清除自动画多边形数据
    changeDrawType() {
      if (this.autoAirSpase) {
        this.map.removeLayer(this.autoAirSpase);
        this.autoAirSpase = null;
      }
      this.$refs.ruleForm.resetFields();
      this.ruleForm.airSpaseCoordinateArr = [{ value: "" }];
      this.ploygonChecked = false;
      this.circleChecked = false;
      this.cancelDrawAll();
    },

    //自动画图形
    autoDraw(arg1, arg2) {
      if (this.ploygonChecked) {
        this.autoAirSpase = L.polygon(arg1, {
          color: "rgba(0,0,0,0.5)", //边框颜色#aa0000
          fillColor: "#30f", //填充颜色
          weight: 1 //边框宽度
        }).addTo(this.map);
      } else if (this.circleChecked) {
        this.autoAirSpase = L.circle(arg1, {
          color: "blue", // 圆的边框颜色
          fillColor: "#30f", // 填充颜色
          fillOpacity: 0.5, // 填充透明度
          radius: arg2 // 半径
        }).addTo(this.map);
      }
    },
    //计算n个坐标中心点
    calculateCenter(points) {
      let latSum = 0;
      let lngSum = 0;
      const n = points.length;
      if (n === 0) return null; // 如果没有点，返回 null
      // 计算所有点的经纬度和
      for (let i = 0; i < n; i++) {
        latSum += points[i][0]; // 纬度
        lngSum += points[i][1]; // 经度
      }
      // 计算平均值
      const centerLat = latSum / n;
      const centerLng = lngSum / n;
      return [centerLat, centerLng]; // 返回中心点 [纬度, 经度]
    },
    //预览自动生成的多边形
    handelPreview() {
      if (this.ploygonChecked) {
        let value = this.ruleForm.airSpaseCoordinateArr;
        if (value.length < 3) {
          this.$message.error({
            message: "空域数组至少为三组",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { }
          });
          return;
        }
        if (this.autoAirSpase) {
          this.map.removeLayer(this.autoAirSpase);
          this.autoAirSpase = null;
        }
        let targetArr = [];
        //地图使用Gcj02 用户输入wgs84需要转化一下
        value.map(v => {
          let point = v.value.split(",");
          let wgsPoint = wgs84ToGcj02(
            parseFloat(point[0]),
            parseFloat(point[1])
          );
          targetArr.push([wgsPoint[1], wgsPoint[0]]);
        });
        this.map.setView(this.calculateCenter(targetArr));
        this.autoDraw(targetArr);
        this.ruleForm.area = this.calculateArea(targetArr);
        this.ruleForm.area = this.calculateArea(
          this.formAirSpaseCoordinateArrData(value)
        );
      }
      if (this.circleChecked) {
        let point = this.ruleForm.center.split(",");
        let wgsPoint = wgs84ToGcj02(parseFloat(point[0]), parseFloat(point[1]));
        let targetArr = [wgsPoint[0], wgsPoint[1]];
        let radius = this.ruleForm.radius;
        if (!this.ruleForm.center || !radius) {
          this.$message.error({
            message: "请完善圆形空域数据",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { }
          });
          return;
        }
        if (this.autoAirSpase) {
          this.map.removeLayer(this.autoAirSpase);
          this.autoAirSpase = null;
        }
        this.autoDraw(targetArr.map(v => parseFloat(v)).reverse(), radius);
        this.map.setView(targetArr.map(v => parseFloat(v)).reverse());
        this.ruleForm.area = this.calculateArea(radius);
        this.airSpaseArrChange = false;
      }
    },
    //选择取消多边形绘制
    handleCheckPloygon() {
      this.circleChecked = false;
      if (this.autoAirSpase) {
        this.map.removeLayer(this.autoAirSpase);
        this.autoAirSpase = null;
      }
      this.$refs.ruleForm.resetFields();
      if (this.ploygonChecked && this.addAirSpaseType === 1) {
        if (this.drawnItems) {
          this.drawnItems.clearLayers();
          this.map.addControl(this.drawControl);
        }
        this.enablePolygonDrawing();
      } else if (this.addAirSpaseType === 1) {
        // this.cancel();
      }
    },
    //选择取消圆形绘制
    handleCheckcircle() {
      if (this.autoAirSpase) {
        this.map.removeLayer(this.autoAirSpase);
        this.autoAirSpase = null;
      }
      this.$refs.ruleForm.resetFields();
      this.ruleForm.airSpaseCoordinateArr = [{ value: "" }];
      this.ploygonChecked = false;
      if (this.circleChecked && this.addAirSpaseType === 1) {
        if (this.drawnItems) {
          this.drawnItems.clearLayers();
          this.map.addControl(this.drawControl);
        }
        this.enableCircleDrawing();
      } else if (this.addAirSpaseType === 1) {
        // this.cancel();
      }
    },
    // 模拟用户点击多边形绘制按钮
    enablePolygonDrawing() {
      var polygonButton = document.getElementsByClassName(
        "leaflet-draw-draw-polygon"
      )[0];
      if (polygonButton) {
        polygonButton.click();
      }
    },
    // 模拟用户点击圆形绘制按钮
    enableCircleDrawing() {
      var polygonButton = document.getElementsByClassName(
        "leaflet-draw-draw-circle"
      )[0];
      if (polygonButton) {
        polygonButton.click();
      }
    },
    //模拟用户点击编辑按钮
    editDrawing() {
      var cancelButton = document.getElementsByClassName(
        "leaflet-draw-edit-edit"
      )[0];
      if (cancelButton) {
        cancelButton.click();
      }
    },
    //模拟用户点击删除按钮（点击删除对应区域）
    removeDraw() {
      var cancelButton = document.getElementsByClassName(
        "leaflet-draw-edit-remove"
      )[0];
      if (cancelButton) {
        cancelButton.click();
      }
    },
    //格式化经纬度
    formatToWgs84(strArr) {
      let res;
      if (this.addAirSpaseType === 2 && this.circleChecked) {
        let point = gcj02ToWgs84(parseFloat(strArr[0]), parseFloat(strArr[1]));
        return [[point[0], point[1]]];
      } else if (this.addAirSpaseType === 2 && this.ploygonChecked) {
        strArr.map(v => {
          console.log(v.value, 75);
        });
        res = strArr.map(v => [
          gcj02ToWgs84(
            v.value.split(",").map(e => parseFloat(e))[0],
            v.value.split(",").map(e => parseFloat(e))[1]
          )
        ]);
        return res;
      }
    },
    //格式化多边形字符串数组
    formAirSpaseCoordinateArrData(arr) {
      return arr.map(v => [
        v.value.split(",").map(e => parseFloat(e))[0],
        v.value.split(",").map(e => parseFloat(e))[1]
      ]);
    },
    //提交
    submitForm(formName) {
      if (
        this.ruleForm.airSpaseCoordinateArr.length < 3 &&
        this.addAirSpaseType === 2 &&
        this.ploygonChecked
      ) {
        this.$message.error({
          message: "空域数组至少为三组",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () { }
        });
        return;
      }
      if (this.ruleForm.date2 <= this.ruleForm.date1) {
        this.$message.error({
          message: "结束时间需大于开始时间",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () { }
        });
        this.ruleForm.date2 = null; // 清空降落时间
        return;
      }
      this.$refs[formName].validate(valid => {
        if (valid && (this.ploygonChecked || this.circleChecked)) {
          // 设置按钮为不可点击状态
          this.isButtonActive = false;
          // 在2秒后重新激活按钮
          setTimeout(() => {
            this.isButtonActive = true;
          }, 2000);
          let center = this.center;
          if (center) {
            let point = gcj02ToWgs84(center.lng, center.lat);
            center = [[point[0].toFixed(7), point[1].toFixed(7)]];
          }
          let radius =
            this.addAirSpaseType === 1
              ? this.ploygonChecked
                ? 0
                : this.radius
              : this.addAirSpaseType === 2
                ? this.ploygonChecked
                  ? 0
                  : this.ruleForm.radius
                : "";
          let airspacePointArry =
            this.addAirSpaseType === 1
              ? this.ploygonChecked
                ? this.latlngs
                : center
              : this.addAirSpaseType === 2
                ? this.ploygonChecked
                  ? this.formAirSpaseCoordinateArrData(
                    this.ruleForm.airSpaseCoordinateArr
                  )
                  : [this.ruleForm.center.split(",")]
                : "";
          //未画完情况
          if (this.addAirSpaseType === 1) {
            if (
              (this.ploygonChecked &&
                !(airspacePointArry && airspacePointArry.length)) ||
              (!this.ploygonChecked &&
                (!(airspacePointArry && airspacePointArry.length) ||
                  !this.center))
            ) {
              this.$message.error({
                message: "请完成图形绘制",
                duration: 1000,
                customClass: "message-warn-s",
                iconClass: "el-icon-warn-tip",
                offset: 470,
                onClose: function () { }
              });
              return;
            }
          }
          let area = this.ruleForm.area;
          // if(this.addAirSpaseType === 1){
          //   //手动则自动获取
          //   area = this.ruleForm.area
          // }else {
          //   if(this.ploygonChecked){
          //     area = this.calculateArea(airspacePointArry)
          //   }else {
          //     this.calculateArea(radius)
          //   }
          // }
          let data = {
            color:
              this.ruleForm.type === 0 || this.ruleForm.type === 1
                ? "red"
                : this.ruleForm.type === 3
                  ? "green"
                  : this.ruleForm.type === 4 || this.ruleForm.type === 21
                    ? "yellow"
                    : this.ruleForm.type === 11
                      ? "orange"
                      : null,

            height: this.ruleForm.height,
            bottomHeight: this.ruleForm.bottomHeight,
            type: Number(this.ruleForm.type),
            shapeType: this.ploygonChecked ? 0 : 1,
            startTime: this.changeData(this.ruleForm.date1),
            alarmTime: this.ruleForm.minute,
            endTime: this.changeData(this.ruleForm.date2),
            reason:
              this.ruleForm.type == 0
                ? "禁飞区"
                : this.ruleForm.type == 3
                  ? "适飞区"
                  : this.ruleForm.type == 1
                    ? "电子围栏"
                    : this.ruleForm.type == 4
                      ? "受限区"
                      : this.ruleForm.type == 11
                        ? "管制空域"
                        : this.ruleForm.type == 21
                          ? "监视空域"
                          : "",
            radius: parseFloat(radius).toFixed(2),
            airspacePointArry: airspacePointArry,
            remark: this.ruleForm.note,
            applicant: this.ruleForm.institution,
            airspaceName: this.ruleForm.name,
            approvingType: this.ruleForm.approvingType,
            approvingUnit: this.ruleForm.approvingUnit,
            area: area,
            regionCode: this.ruleForm.selectedDistrict
              ? this.ruleForm.selectedDistrict
              : this.ruleForm.selectedCity
                ? this.ruleForm.selectedCity
                : this.ruleForm.selectedProvince
          };
          this.postJsonRequest(
            "/uav-task-server/airspace/addAirspace",
            data
          ).then(res => {
            let oData = res.data;
            if (oData.code == 0) {
              this.getRouteData();
              this.$message({
                message: oData.msg,
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470
              });
              this.selectedCity = "";
              this.selectedDistrict = "";
              this.selectedProvince = "";
              this.ploygonChecked = false;
              this.circleChecked = false;
              this.addAirSpaseType = 1;
              this.cancel();
              if (this.autoAirSpase) {
                console.log(22, this.autoAirSpase);
                this.map.removeLayer(this.autoAirSpase);
                this.autoAirSpase = null;
              }
              this.airSpace();
            } else {
              this.$message.error({
                message: oData.msg,
                duration: 1000,
                customClass: "message-warn-s",
                iconClass: "el-icon-warn-tip",
                offset: 470,
                onClose: function () { }
              });
            }
          });
        } else {
          this.$message.error({
            message: "请完善必填项！",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { }
          });
        }
      });
    },
    decimalToDMS(decimal) {
      const degrees = Math.floor(decimal);
      const minutes = Math.floor((decimal - degrees) * 60);
      const seconds = Math.floor(
        Math.round((decimal - degrees - minutes / 60) * 3600 * 1000) / 1000
      ); // 保留千分位
      return `${degrees}° ${minutes}' ${seconds}"`;
    },
    submitFormLine(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 设置按钮为不可点击状态
          let pointArr = [];
          this.latlngsline.forEach((item, index) => {
            let E = this.decimalToDMS(item[0]);
            let N = this.decimalToDMS(item[1]);
            pointArr.push({
              altitude: this.ruleFormLine.altitude,
              latitude: item[1].toFixed(7).toString(),
              longitude: item[0].toFixed(7).toString(),
              name: `E${E}N${N}`,
              type: index == 0 || index == this.latlngsline.length - 1 ? 1 : 0,
              regionCode: this.selectedDistrict
                ? this.selectedDistrict
                : this.selectedCity
                  ? this.selectedCity
                  : this.selectedProvince
            });
          });
          let params = {
            name: this.ruleFormLine.name,
            altitude: this.ruleFormLine.altitude,
            airpointList: pointArr,
            isback: this.ruleFormLine.isback,
            airLineType: this.ruleFormLine.airLineType,
            regionCode: this.ruleFormLine.selectedDistrict
              ? this.ruleFormLine.selectedDistrict
              : this.ruleFormLine.selectedCity
                ? this.ruleFormLine.selectedCity
                : this.ruleFormLine.selectedProvince
          };
          // 检查 手绘航线是否完成
          if (params.airpointList.length === 0) {
            // 如果为空，提示用户
            // alert("请完成航线绘制");
            this.$message.error("请完成航线绘制！");
          } else {
            // 如果不为空，调用接口进行信息新增
            this.saveCAirLineAndCAirPoint(params);
            // 获取航线数据
            this.$refs.ruleFormLine.resetFields();
            if (this.drawnItems) {
              this.drawnItems.clearLayers();
              this.map.addControl(this.drawControl);
            }
            this.open = false;
          }
        } else {
          this.$message.error({
            message: "请完善必填项！",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { }
          });
        }
      });
    },
    saveCAirLineAndCAirPoint(param) {
      return this.postJsonRequest(
        "/uav-task-server/cairline/saveCAirLineAndCAirPoint",
        param
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          this.planeAllWay();
          this.$message({
            message: oData.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () { }
          });
          this.selectedCity = "";
          this.selectedDistrict = "";
          this.selectedProvince = "";
        }
      });
    },
    submit(formName) {
      if (this.shapeType === 0) {
        if (this.airSpaceInfo.airSpaseCoordinateArr.length < 3) {
          this.$message.error({
            message: "空域数组至少为三组",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { }
          });
          return;
        }
      }
      if (this.airSpaceInfo.date2 <= this.airSpaceInfo.date1) {
        this.$message.error({
          message: "结束时间需大于开始时间",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () { }
        });
        this.airSpaceInfo.date2 = null; // 清空降落时间
        return;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let airspacePointArry =
            this.shapeType === 0
              ? this.formAirSpaseCoordinateArrData(
                this.airSpaceInfo.airSpaseCoordinateArr
              )
              : [this.airSpaceInfo.center.split(",")];
          let data = {
            nowName:
              this.airSpaceInfo.type == 0
                ? "禁飞区"
                : this.airSpaceInfo.type == 3
                  ? "适飞区"
                  : this.airSpaceInfo.type == 1
                    ? "电子围栏"
                    : this.airSpaceInfo.type == 4
                      ? "受限区"
                      : this.airSpaceInfo.type == 11
                        ? "管制空域"
                        : this.airSpaceInfo.type == 21
                          ? "监视空域"
                          : "",
            color:
              this.airSpaceInfo.type === 0 || this.airSpaceInfo.type === 1
                ? "red"
                : this.airSpaceInfo.type === 3
                  ? "green"
                  : this.airSpaceInfo.type === 4 || this.airSpaceInfo.type === 21
                    ? "yellow"
                    : this.airSpaceInfo.type === 11
                      ? "orange"
                      : null,
            height: this.airSpaceInfo.height,
            bottomHeight: this.airSpaceInfo.bottomHeight,
            type: this.airSpaceInfo.type,
            shapeType: this.shapeType,
            startTime: this.changeData(this.airSpaceInfo.date1),
            alarmTime: this.airSpaceInfo.minute,
            endTime: this.changeData(this.airSpaceInfo.date2),
            reason:
              this.airSpaceInfo.type == 0
                ? "禁飞区"
                : this.airSpaceInfo.type == 3
                  ? "适飞区"
                  : this.airSpaceInfo.type == 1
                    ? "电子围栏"
                    : this.airSpaceInfo.type == 4
                      ? "受限区"
                      : this.airSpaceInfo.type == 11
                        ? "管制空域"
                        : this.airSpaceInfo.type == 21
                          ? "监视空域"
                          : "",
            radius: this.airSpaceInfo.radius,
            id: this.airSpaceInfo.id,
            airspacePointArry: airspacePointArry,
            remark: this.airSpaceInfo.note,
            applicant: this.airSpaceInfo.institution,
            airspaceName: this.airSpaceInfo.name,
            approvingType: this.airSpaceInfo.approvingType,
            approvingUnit: this.airSpaceInfo.approvingUnit,
            area: this.airSpaceInfo.area,
            regionCode: this.airSpaceInfo.selectedDistrict
              ? this.airSpaceInfo.selectedDistrict
              : this.airSpaceInfo.selectedCity
                ? this.airSpaceInfo.selectedCity
                : this.airSpaceInfo.selectedProvince
          };
          this.postJsonRequest(
            "/uav-task-server/airspace/updateAirspace",
            data
          ).then(res => {
            const oData = res.data;
            if (oData.code == 0) {
              this.getRouteData();
              this.$message({
                message: res.data.msg,
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () { }
              });
              this.airSpace();
              this.flyArea = false;
            } else {
              this.$message.error({
                message: oData.msg,
                duration: 1000,
                customClass: "message-warn-s",
                iconClass: "el-icon-warn-tip",
                offset: 470,
                onClose: function () { }
              });
            }
          });
        }
      });
    },
    cancel() {
      // 将绘制的图层添加到地图上
      if (this.drawnItems) {
        this.drawnItems.clearLayers();
        this.map.addControl(this.drawControl);
      }
      this.$refs.ruleForm.resetFields();
      this.open = false;
      this.center = null;
      this.latlngs = [];
      if (this.ploygonChecked) {
        this.enablePolygonDrawing();
      } else if (this.circleChecked) {
        this.enableCircleDrawing();
      }
    },
    cancelLine() {
      // 将绘制的图层添加到地图上
      if (this.drawnItems) {
        this.drawnItems.clearLayers();
        this.map.addControl(this.drawControl);
      }
      this.$refs.ruleFormLine.resetFields();
      this.open = false;
      this.latlngsline = [];
    },
    //退出画多边形或圆
    cancelDrawAll() {
      // 将绘制的图层添加到地图上
      if (this.drawnItems) {
        this.drawnItems.clearLayers();
        this.map.addControl(this.drawControl);
      }
      this.latlngs = [];
      this.center = [];
    },
    cancelEdit() {
      // 将绘制的图层添加到地图上
      // if (this.drawnItems) {
      //   this.drawnItems.clearLayers();
      //   this.map.addControl(this.drawControl);
      // }
      this.$refs.airSpaceInfo.resetFields();
      this.flyArea = false;
      // if (this.ploygonChecked) {
      //   this.enablePolygonDrawing();
      // } else if (this.circleChecked) {
      //   this.enableCircleDrawing();
      // }
    },
    // 回到主页
    handleBackHome() {
      this.handledataCommand("taskControl");
    },
    // 数据下拉点击
    handledataCommand(command) {
      // console.log('handledataCommand--->', command)
      this.selectMenuIndex = command;
      this.$emit("backTwoMap", command);
      // 存储selectMenuIndex 到 webStorage中，用于刷新时返回到本页面
      sessionStorage.setItem("selectMenuIndex", command);
    },
    changeData(date) {
      var date = new Date(date);
      // 获取年、月、日、时、分、秒
      var year = date.getFullYear();
      var month = date.getMonth() + 1; // getMonth() 返回0-11，需要加1
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      // 为月、日、时、分、秒添加前导0，如果它们小于10
      month = (month < 10 ? "0" : "") + month;
      day = (day < 10 ? "0" : "") + day;
      hours = (hours < 10 ? "0" : "") + hours;
      minutes = (minutes < 10 ? "0" : "") + minutes;
      seconds = (seconds < 10 ? "0" : "") + seconds;
      // 构建并返回格式化的日期时间字符串
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    // 点击右侧展开按钮
    handleOpenRight() {
      this.openRight = !this.openRight;
      this.openLeft = true;
      const targetDiv = document.querySelector("div.leaflet-top.leaflet-left");
    },
    //绘制所有计划航道
    planeAllWay(queryCode) {
      const code = queryCode ? queryCode : "";
      //分页查询所有航线，cairline/queryAllCAirline?currentpage=1&pagesize=100
      return this.getRequest(
        "/uav-task-server/cairline/queryAllCAirline?pagesize=500&currentpage=1&regionCode=" +
        code
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let list = oData.data.list;
          if (list && list.length > 0) {
            if (this.planLines.length > 0) {
              this.planLines.forEach(planline => {
                this.map.removeLayer(planline);
                this.planLines = [];
              });
            }
            if (this.planlineWhite.length > 0) {
              this.planlineWhite.forEach(v => {
                this.map.removeLayer(v);
              });
              this.planlineWhite = [];
            }
            list.forEach(airLine => {
              let airLineData = [];
              let points = [];
              airLine.airpointList.forEach(airpoint => {
                let point = wgs84ToGcj02(airpoint.longitude, airpoint.latitude);
                airLineData.push([point[1], point[0]]);
                points.push({
                  po: [point[1], point[0]],
                  name: airpoint.name,
                  altitude: airpoint.altitude,
                  type: airpoint.type
                });
              });
              this.planeWay(
                airLineData,
                points,
                airLine.airLineType,
                "plan",
                airLine.altitude,
                airLine.name,
                airLine.configdence?JSON.parse(airLine.configdence).weightedScore:''
              );
            });
          }
        } else {
          this.$message.error({
            message: "网络请求失败",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { }
          });
        }
      });
    },
    //绘制航道
    planeWay(wayPoints, points, wayType, type, altitude, name,weightedScore) {
      const _this = this;
      // let weight = 8;
      // if (this.currentZoom < 10) {
      //   weight = 4;
      // } else if (this.currentZoom >= 10 && this.currentZoom <= 12) {
      //   weight = 8;
      // } else {
      //   weight = 12;
      // }
      // 0：观光 1：巡检 2：物流
      let waycolor =
        wayType == 1
          ? "#b5b500"
          : wayType == 0
            ? "#008000"
            : wayType == 2
              ? "#0000ff"
              : wayType == 3
                ? "#fd5939"
                : "#0000ff";
      // if (!wayType) {
      //   waycolor = "#0000ff";
      // }
      if (this.positionLines) {
        this.map.removeLayer(this.positionLines);
        this.positionLines = null;
      }
      if (this.positRoadWhite) {
        this.map.removeLayer(this.positRoadWhite);
        this.positRoadWhite = null;
      }

      //绘制航线上的斜线
      let planlineWhite = null;
      // 创建一个折线
      if (this.showDubuleLine) {
        planlineWhite = L.polyline(wayPoints, {
          smoothFactor: 1,
          color: "#fff", //航道底部颜色
          opacity: 0.8,
          weight: 9, //航道底部宽度
          lineCap: "butt",
          lineJoin: "round" // 线条连接处样式
        }).addTo(this.map);
      }

      function togglePopup(latlng, showPopup, map) {
        let popup;
        if (showPopup) {
          popup = L.popup({
            closeButton: false // 设置closeButton为false来隐藏关闭按钮
          })
            .setLatLng(latlng)
            .setContent(
              `<span style="color:#000;font-weight:bold;">${name}(${altitude}m)</span>`
            )
            .openOn(map);
        } else {
          popup && popup.close();
        }
      }

      // 添加 hover 事件监听器 航线移入移出
      // if (planlineWhite) {
      //   planlineWhite.on('mouseover', function (e) {
      //     //这里this指向map
      //     togglePopup(e.latlng, true, _this.map);
      //   });
      //   planlineWhite.on('mouseout', function (e) {
      //     togglePopup(e.latlng, false, _this.map, e);
      //   });
      // }

      let planline = L.polyline(wayPoints, {
        smoothFactor: 1,
        color: waycolor, //航道颜色
        opacity: 0.8,
        weight: this.showDubuleLine ? 5 : 2, //航道宽度
        lineCap: "butt",
        lineJoin: "round", // 线条拐角样式
        dashArray: this.showDubuleLine ? "10,2" : null, // 虚线，例如'10,10'表示10像素的实线和10像素的空白交替出现
        dashOffset: "1", // 虚线偏移量
        zIndex: 10 // 设置折线的 zIndex 属性
      }).addTo(this.map);
      planline.bindTooltip(name+ (weightedScore?`(${weightedScore})`:''), {
        autoPan: false,
        zIndexOffset: 1100,
        direction: "auto",
        permanent: this.showAirLineName ? true : false,
        className: "planlineName"
      });
      planline.on("mouseover", function (e) {
        //这里this指向map
        togglePopup(e.latlng, true, _this.map);
      });
      planline.on("mouseout", function (e) {
        togglePopup(e.latlng, false, _this.map, e);
      });
      if (planlineWhite) {
        planline.on("mouseover", function (e) {
          //这里this指向map
          togglePopup(e.latlng, true, _this.map);
        });
        planline.on("mouseout", function (e) {
          togglePopup(e.latlng, false, _this.map, e);
        });
      }
      this.drawAirLinePorts(points, type);
      if (type == "plan") {
        if (planlineWhite) {
          this.planlineWhite.push(planlineWhite);
        }
        this.planLines.push(planline);
      } else if (type == "run") {
        this.runLines.push(planline);
        if (planlineWhite) {
          this.runRoadWhites.push(planlineWhite);
        }
      } else if (type == "position") {
        this.positionLines = planline;
        if (planlineWhite) {
          this.positRoadWhite = planlineWhite;
        }
      }
    },
    //绘制航道上的航点
    drawAirLinePorts(pointData, type) {
      if (!this.showNormalairPort) {
        pointData = pointData.filter(v => v.type !== 0);
      }
      if (!this.showairPort) {
        pointData = pointData.filter(v => {
          return v.type !== 1 && v.type !== 2;
        });
      }
      if (pointData.length > 0) {
        pointData.forEach((item, index) => {
          //设置图标样式
          let myIcon = L.icon({
            iconUrl: `../../../static/${(this.showairPort &&
              (index === 0 || index === pointData.length - 1)) ||
              item.type === 1 ||
              item.type === 2
              ? "landPoint"
              : "normalPoint"
              }.png`,
            iconSize:
              (this.showairPort &&
                (index === 0 || index === pointData.length - 1)) ||
                item.type === 1 ||
                item.type === 2
                ? [45, 45]
                : [20, 20]
          });
          let markerPoint = L.marker(item.po, {
            icon: myIcon
          }).addTo(this.map);
          // 将 markerToTop 提升
          markerPoint.setZIndexOffset(1000);
          markerPoint.bindTooltip(
            `<span style="color:#000;font-weight:bold;">${item.name +
            "(" +
            item.altitude +
            "m)"}</span>`,
            {
              //内容可以自定义为HTML，如：<div>自定义结构</div>
              direction: "bottom", // 显示在底部
              sticky: false,
              offset: [0, 0] // 中心位置
            }
          );
          if (type == "position") {
            this.airLinePositions.push(markerPoint);
          } else {
            this.airLinePorts.push(markerPoint);
          }
        });
      }
    },

    //绘制航点
    airPort() {
      this.getRequest(
        "/uav-task-server/cpoint/queryAllCPoint?pagesize=700&currentpage=1"
      ).then(res => {
        let oData = res.data;
        if (0 == oData.code) {
          let pointDataList = oData.data.list;
          // this.drawAirPorts(pointDataList);
        }
      });
    },
    drawAirPorts(pointDataList) {
      let airPorts = [];
      pointDataList.forEach(item => {
        if (item.type === 2) {
          const customMarker = L.divIcon({
            className: "custom-marker",
            iconUrl: "../../../static/xian_fei.png",
            html: `<div title=${item.name} style="color:#
            000;font-weight:bold;overflow:hidden;width:110px;text-overflow: ellipsis;white-space: nowrap;">${item.name}</div>`,
            iconSize: [120, 135],
            iconAnchor: [60, 135] // 锚点设置为底部中心
          });
          let center = wgs84ToGcj02(item.longitude, item.latitude);
          let markerPoint = L.marker([center[1], center[0]], {
            icon: customMarker
          });
          airPorts.push(markerPoint);
        }
      });
      this.airPorts = airPorts;
      // 创建聚合标记组
      this.markers = L.markerClusterGroup({
        maxClusterRadius: 10, //设置最大聚类半径
        spiderfyOnMaxZoom: true,
        zIndex: 11 // 设置聚合点 zIndex 属性
      });
      // 添加聚合标记
      this.markers.addLayers(this.airPorts); //一次性聚合所有航点
      this.map.addLayer(this.markers);
    },
    handleResize() {
      this.myChart1 && this.myChart1.resize();
      this.myChart2 && this.myChart2.resize();
      this.myChart3 && this.myChart3.resize();
      this.myChart4 && this.myChart4.resize();
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/home/MunicipalLevelData.scss";
</style>



// WEBPACK FOOTER //
// src/components/home/MunicipalLevelData.vue